<template>
  <div class="logistic">
    <!--设置查看-->
    <Modal v-model="logisticsChannelModal" :title="logisticsChannelTitle" width="1200" class-name="logisticStyles"
      :transfer="false" :mask-closable="false" @on-visible-change="visible2" :styles="{top: '40px'}" :before-close="handleBeforeClose">
      <!--渠道基础信息-->
      <Card class="set_card_style mb20" :bordered="true" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005288') }}</h2>
        </template>
        <Form :label-width="90" :disabled="looKsettings" @submit.native.prevent>
          <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
            <template v-for="item in multilingualNamesList">
              <template :slot="item.name">
                <Col :span="20">
                  <span class="fontBold" :class="item.code === 'zh-CN' ?'redDot' : ''">{{ $t('key1000222') + item.title + $t('key1002424') }}</span>
                  <span v-if="ymsLogisticsChannelTalg || openType === 'look'">
                    {{ logisticsChannelModalParams.carrierShippingMethod['carrierShippingMethodName_' + item.code] }}
                  </span>
                  <Input
                    v-else
                    style="width: 300px;"
                    size="small"
                    v-model="logisticsChannelModalParams.carrierShippingMethod['carrierShippingMethodName_' + item.code]"
                    :key="'cccccc'"
                    :maxlength="100"/>
                </Col>
                <div class="mt20 flex">
                  <span class="fontBold">{{ item.title + $t('key1005286') }}</span>
                  <span v-if="ymsLogisticsChannelTalg || openType === 'look'">
                    {{ logisticsChannelModalParams.carrierShippingMethod['remark_' + item.code] }}
                  </span>
                  <Input v-else style="width: 600px;"
                    v-model.trim="logisticsChannelModalParams.carrierShippingMethod['remark_' + item.code]"
                    type="textarea"/>
                </div>
              </template>
            </template>
          </languagesTabs>
          <Row class="mt20">
            <Col span="12">
              <span class="fontBold">{{ $t('key1001579') }}</span>
              {{ logisticsChannelModalParams.carrierShippingMethod.carrierName }}
            </Col>
            <Col span="11" v-if="logisticsChannelModalParams.carrierShippingMethod.carrierType">
              <span class="fontBold">{{ $t('key1005289') }}</span>
              <span v-if="logisticsChannelModalParams.carrierShippingMethod.carrierType === 1">{{ $t('key1005290') }}</span>
              <span v-if="logisticsChannelModalParams.carrierShippingMethod.carrierType === 2">{{ $t('key1005291') }}</span>
            </Col>
          </Row>
          <Row class="mt20">
            <Col :span="12" class="mb20">
              <span class="fontBold redDot">{{ $t('key1005292') }}</span>
              <span v-if="ymsLogisticsChannelTalg || openType === 'look'">
                {{ logisticsChannelModalParams.carrierShippingMethod.carrierShippingMethodCode }}
              </span>
              <Input
                v-else
                style="width: 300px;"
                size="small"
                clearable
                v-model.trim="logisticsChannelModalParams.carrierShippingMethod.carrierShippingMethodCode"
                :maxlength="100"/>
            </Col>
            <Col :span="12" v-if="carrierCode === 'temuHalfTl'">
              <span class="fontBold redDot">{{ $t('key1005293') }}</span>
              <span v-if="ymsLogisticsChannelTalg || openType === 'look'">
                {{ logisticsChannelModalParams.carrierShippingMethod.logisticsInterface }}
              </span>
              <Input
                v-else
                style="width: 300px;"
                size="small"
                clearable
                v-model.trim="logisticsChannelModalParams.carrierShippingMethod.logisticsInterface"
                :maxlength="100"/>
            </Col>
            <Col :span="12" class="mb20" v-if="isOnline === 1">
              <span class="fontBold redDot">{{ $t('key1005294') }}</span>
              <span v-if="openType === 'look'">
                {{ getPerformanceMethodName(logisticsChannelModalParams.carrierShippingMethod.performanceType) }}
              </span>
              <Select
                v-else
                class="w300"
                filterable
                v-model="logisticsChannelModalParams.carrierShippingMethod.performanceType">
                <Option v-for="item in performanceMethodlist" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
            </Col>
            <Col :span="12" v-if="carrierCode === 'temuHalfTl'">
              <span class="fontBold redDot">shipCompanyId：</span>
              <span v-if="ymsLogisticsChannelTalg || openType === 'look'">
                {{ logisticsChannelModalParams.carrierShippingMethod.shipCompanyId }}
              </span>
              <Input
                v-else
                style="width: 300px;"
                size="small"
                clearable
                v-model.trim="logisticsChannelModalParams.carrierShippingMethod.shipCompanyId"
                :maxlength="100"/>
            </Col>
            <Col :span="12">
              <span class="fontBold">{{ $t('key1005295') }}</span>
              <span v-if="ymsLogisticsChannelTalg || openType === 'look'">
                {{ logisticsCarrierName }}
              </span>
              <Select
                style="width: 300px;"
                v-else
                v-model.trim="logisticsCarrier"
                filterable
                :loading="selectLoading"
                clearable
                :remote-method="selectQueryChange"
                v-select-more="selectMore">
                <Option v-for="item in logisticsCarrierData" :value="item.nameCn">{{ item.nameCn }}</Option>
              </Select>
            </Col>
          </Row>
          <Row class="mt20">
            <Col :span="12" class="flex">
              <span class="fontBold">{{ $t('key1005296') }}</span>
              <div v-if="ymsLogisticsChannelTalg || openType === 'look'">
                <span>{{ logisticsChannelModalParams.carrierShippingMethod.minEfficiency }}</span>
                <span> - </span>
                <span>{{ logisticsChannelModalParams.carrierShippingMethod.maxEfficiency }}</span>
                <span>{{ $t('key1001631') }}</span>
              </div>
              <div v-else>
                <InputNumber
                  size="small"
                  class="w100"
                  :min="0"
                  :max="999"
                  @on-blur="blurChange"
                  v-model="logisticsChannelModalParams.carrierShippingMethod.minEfficiency"/>
                -
                <InputNumber
                  :min="0"
                  size="small"
                  :max="999"
                  class="w100"
                  @on-blur="blurChange"
                  v-model="logisticsChannelModalParams.carrierShippingMethod.maxEfficiency"/>
                {{ $t('key1000411') }}
              </div>
            </Col>
            <Col :span="11" v-if="!ymsLogisticsChannelTalg">
              <span class="fontBold">{{ $t('key1005297') }}</span>
              <span v-if="openType === 'look'"> {{
                  logisticsChannelModalParams.carrierShippingMethod.isInsurance === 1 ? 'Y' : 'N'
                }}</span>
              <Select
                v-else
                class="w300"
                size="small"
                filterable
                v-model="logisticsChannelModalParams.carrierShippingMethod.isInsurance">
                <Option v-for="item in YesOrNolist" :key="item.value" :value="item.value">
                  {{ item.label }}
                </Option>
              </Select>
            </Col>
          </Row>
          <Row class="mt20">
            <Col :span="12" class="flex">
              <span class="fontBold">{{ $t('key1005298') }}</span>
              <div v-if="ymsLogisticsChannelTalg || openType === 'look'">
                <span>{{ logisticsChannelModalParams.carrierShippingMethod.maxLength }}</span>
                <span>*</span>
                <span>{{ logisticsChannelModalParams.carrierShippingMethod.maxWidth }}</span>
                <span>*</span>
                <span>{{ logisticsChannelModalParams.carrierShippingMethod.maxHeight }}</span>
              </div>
              <div v-else>
                <InputNumber
                  :min="0"
                  :max="999999"
                  @on-blur="blurChange"
                  v-model="logisticsChannelModalParams.carrierShippingMethod.maxLength"
                  size="small">
                </InputNumber>
                *
                <InputNumber
                  :min="0"
                  :max="999999"
                  @on-blur="blurChange"
                  v-model="logisticsChannelModalParams.carrierShippingMethod.maxWidth"
                  size="small">
                </InputNumber>
                *
                <InputNumber
                  :min="0"
                  :max="999999"
                  @on-blur="blurChange"
                  v-model="logisticsChannelModalParams.carrierShippingMethod.maxHeight"
                  size="small">
                </InputNumber>
              </div>
            </Col>
            <Col :span="11" class="flex">
              <span class="fontBold">{{ $t('key1005299') }} (g)：</span>
              <div v-if="ymsLogisticsChannelTalg || openType === 'look'">
                <span>{{ logisticsChannelModalParams.carrierShippingMethod.minWeight }}</span>
                <span> - </span>
                <span>{{ logisticsChannelModalParams.carrierShippingMethod.maxWeight }}</span>
              </div>
              <div v-else>
                <InputNumber
                  :min="0"
                  :max="999999"
                  @on-blur="blurChange"
                  v-model="logisticsChannelModalParams.carrierShippingMethod.minWeight"
                  size="small">
                </InputNumber>
                <span style="margin:0 5px;">{{ $t('key1000773') }}</span>
                <InputNumber
                  :min="0"
                  :max="999999"
                  @on-blur="blurChange"
                  v-model="logisticsChannelModalParams.carrierShippingMethod.maxWeight"
                  size="small">
                </InputNumber>
              </div>
            </Col>
          </Row>
          <Row class="mt20">
            <Col :span="12">
              <span class="fontBold">{{ $t('key1005300') }}</span>
              <span v-if="ymsLogisticsChannelTalg || openType === 'look'">
                        {{ logisticsChannelModalParams.carrierShippingMethod.maxPerimeter }}
                      </span>
              <InputNumber
                v-else
                :min="0"
                :max="999999"
                @on-blur="blurChange"
                v-model="logisticsChannelModalParams.carrierShippingMethod.maxPerimeter"
                size="small">
              </InputNumber>
            </Col>
            <Col :span="12">
              <span class="fontBold">{{ $t('key1005301') }}</span>
              <span v-if="ymsLogisticsChannelTalg || openType === 'look'">
                        {{ logisticsChannelModalParams.carrierShippingMethod.maxDimensionsLength }}
                      </span>
              <InputNumber
                v-else
                :min="0"
                :max="999999"
                @on-blur="blurChange"
                v-model="logisticsChannelModalParams.carrierShippingMethod.maxDimensionsLength"
                size="small">
              </InputNumber>
            </Col>
          </Row>
          <Row class="mt20">
            <Col :span="12" class="flex">
              <span class="fontBold">{{ $t('key1005302') }}</span>
              <div v-if="ymsLogisticsChannelTalg || openType === 'look'">
                <span>{{ logisticsChannelModalParams.carrierShippingMethod.minVolume }}</span>
                <span> - </span>
                <span>{{ logisticsChannelModalParams.carrierShippingMethod.maxVolume }}</span>
              </div>
              <div v-else>
                <InputNumber
                  :min="0"
                  :max="999999"
                  v-model="logisticsChannelModalParams.carrierShippingMethod.minVolume"
                  @on-blur="blurChange"
                  size="small"/>
                {{ $t('key1000773') }}
                <InputNumber
                  :min="0"
                  :max="999999"
                  @on-blur="blurChange"
                  v-model="logisticsChannelModalParams.carrierShippingMethod.maxVolume"
                  size="small"/>
              </div>
            </Col>
          </Row>
          <Row class="mt20" v-if="!ymsLogisticsChannelTalg">
            <Col :span="11">
              <span class="fontBold">{{ $t('key1005303') }}</span>
              <span v-if="openType === 'look'">{{
                  logisticsChannelModalParams.carrierShippingMethod.trackUrl
                }}</span>
              <Input
                v-else
                style="width:260px"
                size="small"
                v-model='logisticsChannelModalParams.carrierShippingMethod.trackUrl'/>
            </Col>
          </Row>
        </Form>
      </Card>
      <Form ref="shippingParams" :label-width="120" :disabled="looKsettings" label-position="right" @submit.native.prevent>
        <!--交货方式-->
        <Card class="set_card_style mb20" :bordered="true" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1004023') }}</h2>
          </template>
          <Form ref="deliveryMethodForm" :model="deliveryMethodForm" :label-width="100" :rules="ruleValidate"
            :disabled="looKsettings" @submit.native.prevent>
            <Row type="flex" :gutter="gutterItem">
              <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
                <FormItem :label="$t('key1005276')">
                  <Select v-model="deliveryMethodForm.deliveryType" style="width: 250px;" @on-change="deliveryMethodChange">
                    <Option v-for="item in deliveryMethodList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol" v-show="deliveryMethodForm.deliveryType === 1">
                <FormItem :label="$t('key1005277')" prop="domesticExpressFee">
                  <div class="flex align-items-center">
                    <InputNumber :min="0" :max="99999999"
                      v-model.trim="deliveryMethodForm.domesticExpressFee" :placeholder="$t('key1000324')"
                      :formatter="(value) => formatterNumber(value, 2)" style="width: 150px;">
                    </InputNumber>
                    <span class="ml5">{{ currencyState + $t('key1002442') }}</span>
                  </div>
                </FormItem>
              </Col>
              <div class="flex flex-direction" v-show="deliveryMethodForm.deliveryType === 1">
                <h2 class="color-333 font-weight-bold font-size-14 mt10 mb10">{{ $t('key1005304') }}</h2>
                <div class="font-size-12 pt8 mb20">
                  <span>{{ $t('key1005305') }}</span>
                  <RadioGroup v-model="deliveryMethodForm.deliveryAddressType" class="reset_radio_styles">
                    <Radio :label="1">{{ $t('key1005306') }}</Radio>
                    <Radio :label="2">{{ $t('key1005307') }}</Radio>
                  </RadioGroup>
                </div>
                <Row type="flex" :gutter="gutterItem" v-show="deliveryMethodForm.deliveryType === 1 && deliveryMethodForm.deliveryAddressType === 1">
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                    <Form-item :label="$t('key1002436')" prop="ymsAddressTemplateId">
                      <div class="flex align-items-center">
                        <Select
                          @on-change="(val)=>selectChange(val)"
                          @on-open-change="openChange"
                          v-model="deliveryMethodForm.ymsAddressTemplateId"
                          filterable
                          style="width: 210px;">
                          <Option v-for="(item, index) in addressTemplateData" :value="item.ymsAddressTemplateId" :label="item.addressName" :key="index">
                            <span v-html="item.templateName"></span>
                          </Option>
                        </Select>
                        <span class="cursor themeColor ml8 font-size-13" @click="addAddressTemplateBtn">{{ $t('key1000718') }}</span>
                      </div>
                    </Form-item>
                    <Row type="flex" :gutter="gutterItem" class="font-size-12 mt24" style="margin-left: 23px"
                      v-if="Object.keys(deliveryMethodForm.addressDetails).length >0">
                      <Col :span="24" class="basic_item" v-for="ele in addressInfoList">
                        <span class="basic_title">{{ ele.title + '：' }}</span>
                        <span class="basic_txt" style="max-width: initial;" :title="deliveryMethodForm.addressDetails[ele.paramsKey]">
                        {{ deliveryMethodForm.addressDetails[ele.paramsKey] || '--' }}
                      </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Row>
          </Form>
        </Card>
        <!--物流商可选设置(默认设置)-->
        <Card class="set_card_style mb20" :bordered="true" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1005308') }}</h2>
          </template>
          <Row type="flex" :gutter="gutterItem" v-if="shippingParams.carrierParams && shippingParams.carrierParams.length > 0">
            <Col :xxl="threeItemCol" :xl="threeItemCol" :lg="threeItemCol" :md="threeItemCol">
              <template v-for="(item, cpIndex) in shippingData.carrierParams">
                <FormItem v-show="false" :label="item.paramName + '：'" prop="paramValue" :key="cpIndex" v-if="item.paramType === 'hide'">
                  <!-- 缓存数据，不显示 -->
                  <span v-if="item.paramType === 'hide'" v-show="false">
                    {{ shippingParams.carrierParams[cpIndex].paramValue }}
                  </span>
                </FormItem>
                <FormItem :label="item.paramName + '：'" prop="paramValue" v-else>
                  <Input v-if="item.paramType === 'input'" v-model.trim="shippingParams.carrierParams[cpIndex].paramValue"></Input>
                  <Select v-if="item.paramType === 'select'" filterable v-model="shippingParams.carrierParams[cpIndex].paramValue">
                    <Option
                      v-for="(subItem,t) in item.carrierParamDictionaryList"
                      :key="t"
                      :value="subItem.itemValue">
                      {{ subItem.itemName }}
                    </Option>
                  </Select>
                  <RadioGroup
                    v-if="item.paramType === 'radio'"
                    v-model="shippingParams.carrierParams[cpIndex].paramValue">
                    <Radio
                      v-for="(subItem,t) in item.carrierParamDictionaryList"
                      :key="t"
                      :label="subItem.itemValue">
                      {{ subItem.itemName }}
                    </Radio>
                  </RadioGroup>
                  <CheckboxGroup
                    v-if="item.paramType === 'check'"
                    v-model="shippingParams.carrierParams[cpIndex].paramValue">
                    <Checkbox
                      v-for="(subItem,t) in item.carrierParamDictionaryList"
                      :key="t"
                      :label="subItem.itemValue">
                    </Checkbox>
                  </CheckboxGroup>
                </FormItem>
              </template>
            </Col>
          </Row>
        </Card>
        <!--派送范围及运费-->
        <Card class="set_card_style mb20" :bordered="true" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1005309') }}</h2>
          </template>
          <div class="p10">
            <p class="fontWeight mb5">{{ $t('key1005310') }}</p>
            <span v-if="openType === 'look'">{{ arriveableTypeText }}</span>
            <RadioGroup v-model="arriveableType" v-else>
              <Radio v-for="(item,index) in sendUsageTypeList" :key="index" :label="item.value" class="mr20">
                <span>{{ item.name }}</span>
              </Radio>
            </RadioGroup>
          </div>
          <div class="p10">
            <div class="flex align-items-center justify-content-between mb10">
              <span class="fontWeight">{{ $t('key1005311') }}</span>
              <div v-if="openType !== 'look'" class="flex align-items-center">
                <Button size="small" @click="channelCitation" class="mr5">{{ $t('key1005312') }}</Button>
                <div class="mr5 flex align-items-center">
                  <Button size="small" v-if="accept === 0" class="mr5"
                    @click="$refs.importFreightTemplate.initImportFreightTemplateData(shippingMethodId, arriveableType)">{{ $t('key1005313') }}</Button>
                  <Button size="small" @click="addPartition" v-show="arriveableType !== 1">{{ $t('key1005314') }}</Button>
                </div>
              </div>
            </div>
            <Row type="flex" justify="start" :gutter="20" align="middle">
              <Col>
                <Row type="flex" justify="start" :gutter="5" align="middle">
                  <span class="redColor">*</span>
                  <span>{{ $t('key1005315') }}</span>
                  <Col>
                    <span v-if="openType === 'look'">{{ freightCurrencyText }}</span>
                    <Select v-model="freightCurrency" filterable v-else>
                      <Option
                        v-for="(item, itemIndex) in currencyList"
                        :key="itemIndex"
                        :value="item.value">
                        {{ item.label }}
                      </Option>
                    </Select>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row type="flex" justify="start" :gutter="5" align="middle">
                  <Col>
                <span v-if="openType === 'look'">
                  {{ getEnumName(enumData, 'YmsLogisServicePriceModelFreightDiscountTypeCoreEnum', freightDiscountType) }}
                </span>
                    <Select v-model="freightDiscountType" v-else>
                      <Option v-for="item in freightDiscountTypeList" :value="item.value">{{ item.name }}</Option>
                    </Select>
                  </Col>
                  <Col>
                    <span v-if="openType === 'look'">{{ freightDiscount.toFixed(2) }}</span>
                    <InputNumber v-else :precision="4" :min="0" v-model="freightDiscount" :max="1"/>
                  </Col>
                </Row>
              </Col>
              <Col v-if="openType !== 'look'">
                <span class="redColor">{{ $t('key1005316') }}</span>
              </Col>
            </Row>
            <Table
              :highlight-row="false"
              border
              :columns="columns4"
              class="mt20"
              :data="data4"
              max-height="300">
            </Table>
          </div>
          <!--物流单作废费-->
          <div class="p10">
            <h2 class="font-weight-bold font-size-15 color-333">{{ $t('key1003954') }}</h2>
            <p class="flex align-items-center  mb8 mt8">
              <span class="color-666">{{ $t('key1005317') }}</span>
              <span class="redColor">{{ $t('key1005318') }}</span>
            </p>
            <div class="flex align-items-center">
              <span>{{ $t('key1005319') }}</span>
              <RadioGroup v-model="isCollectCancel">
                <Radio :label="0" class="mr30">{{ $t('key1005320') }}</Radio>
                <Radio :label="1">{{ $t('key1005321') }}</Radio>
              </RadioGroup>
              <template v-if="isCollectCancel === 1">
                <span class="ml100">{{ $t('key1005322') }}</span>
                <RadioGroup v-model="collectCancelType" @on-change="feeCollectionMethodTypeChange">
                  <Radio :label="2" class="mr30">{{ $t('key1005323') }}</Radio>
                  <Radio :label="1">{{ $t('key1005324') }}</Radio>
                </RadioGroup>
              </template>
            </div>
            <div class="flex align-items-center mb12 mt10" v-if="isCollectCancel === 1">
              <span class="redColor mr3">*</span>
              <span>{{ $t('key1005325') }}</span>
              <span v-if="openType === 'look'">{{ currencySystemText }}</span>
              <Select v-model="currencySystem" filterable v-else style="width:200px;" @on-change="currencySystemChange">
                <Option v-for="(item, itemIndex) in currencyList" :key="itemIndex" :value="item.value">{{ item.label }}</Option>
              </Select>
            </div>
            <Form class="flex flex-direction" :disabled="looKsettings" v-if="isCollectCancel === 1">
              <Form-item>
                <div class="flex align-items-center mb24" style="position: relative;" v-for="(item,idx) in feeCollectionConfigList">
                  <span class="mr8">{{ $t('key1005326') }}</span>
                  <Form-item :class="(item.startErrorText || item.errorText) && !item.disabled ? 'ivu-form-item-error errorTextBox' : ''">
                    <InputNumber
                      :disabled="item.disabled"
                      style="width: 100px"
                      :min="0"
                      :max="9999999"
                      :formatter="(value) => formatterNumber(value, 2)"
                      @on-blur="verificationInterval(item, idx, 'left')"
                      v-model.trim="item.minHour">
                    </InputNumber>
                    <span v-if="item.startErrorText && !item.disabled" class="font-size-12 redColor errorTxt">{{ item.startErrorText }}</span>
                  </Form-item>
                  <span class="ml8 mr8">-</span>
                  <Input :disabled="true" style="width: 100px;" v-if="idx === feeCollectionConfigList.length - 1" v-model.trim="infinite"></Input>
                  <Form-item v-else :class="item.endErrorText || item.errorText ? 'ivu-form-item-error errorTextBox' : ''">
                    <InputNumber
                      style="width: 100px"
                      :min="0"
                      :max="9999999"
                      :formatter="(value) => formatterNumber(value, 2)"
                      @on-blur="blurEndInput(item, idx)"
                      v-model.trim="item.maxHour">
                    </InputNumber>
                    <span v-if="item.endErrorText" class="font-size-12 redColor errorTxt">{{ item.endErrorText }}</span>
                  </Form-item>
                  <span class="display-inline-block width_165 mr20 ml8" :style="idx === feeCollectionConfigList.length - 1 ? {visibility: 'hidden'} : {}">
                  {{ $t('key1005287') + (item.maxHour ? Number(item.maxHour.toFixed(2)) : ' ') + 'h）' }}
                </span>
                  <template v-if="collectCancelType === 2">
                    <Form-item :class="item.priceText ? 'ivu-form-item-error errorTextBox' : ''">
                      <div class="flex align-items-center">
                        <span class="mr8">{{ $t('key1005327') }}</span>
                        <InputNumber
                          style="width: 150px"
                          :min="0"
                          :max="9999999"
                          :formatter="(value) => formatterNumber(value, 2)"
                          @on-blur="verificationInterval(item, idx, 'price')"
                          v-model.trim="item.invalidFees">
                        </InputNumber>
                      </div>
                      <span v-if="item.priceText" :style="collectCancelType === 2 ? {left: '178px'} : {left: '193px'}"
                        class="font-size-12 redColor errorPriceTxt">{{ item.priceText }}</span>
                    </Form-item>
                    <span class="ml8">{{ '(' + item.currency + ')' }}</span>
                  </template>
                  <template v-else>
                    <Form-item :class="item.priceText ? 'ivu-form-item-error errorTextBox' : ''">
                      <div class="flex align-items-center">
                        <span class="mr8">{{ $t('key1005328') }}</span>
                        <InputNumber
                          style="width: 150px"
                          :min="0"
                          :max="9999999"
                          :formatter="(value) => formatterNumber(value, 2)"
                          @on-blur="verificationInterval(item, idx, 'price')"
                          v-model.trim="item.logisticsFee">
                        </InputNumber>
                      </div>
                      <span v-if="item.priceText" :style="collectCancelType === 2 ? {left: '178px'} : {left: '193px'}"
                        class="font-size-12 redColor errorPriceTxt">{{ item.priceText }}</span>
                    </Form-item>
                    <span class="ml8 mr4">%</span>
                    <span>{{ $t('key1005329') }}</span>
                  </template>
                  <template v-if="!looKsettings">
                    <Icon type="ios-trash" size="22" color="#EB422F" v-if="idx !==feeCollectionConfigList.length -1"
                      class="ml10 cursor" @click="deleteFeeCollectionConfigBtn(idx)"/>
                    <Icon type="md-add-circle" size="21" color="#2D8CF0" v-else
                      class="ml10 cursor" @click="addAFeeCollectionConfigBtn(idx)"/>
                  </template>
                  <span v-if="item.errorText && !isValueEmpty(item.minHour) && !isValueEmpty(item.maxHour)" class="font-size-12 redColor errorStyles">
                    {{ item.errorText }}
                  </span>
                </div>
              </Form-item>
            </Form>
          </div>
        </Card>
        <!--适用仓库-->
        <Card class="set_card_style mb20" :bordered="true" dis-hover v-if="apiType === 0">
          <template #title>
            <div class="flex align-items-center">
              <h2 class="title_box">{{ $t('key1005330') }}</h2>
              <Tooltip max-width="500" placement="top" transfer
                :content="$t('key1005278')">
                <Icon class="cursor ml5" color="#2D8CF0" style="position: relative; top: -1px;" size="20" type="md-alert"/>
              </Tooltip>
            </div>
          </template>
          <div v-if="!ymsLogisticsChannelTalg">
            <div v-show="type === '01'" class="modalItemContent clear">
              <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
                <Checkbox :value="checkAll" @click.prevent.native="handleCheckAll">{{ $t('key1005331') }}</Checkbox>
              </div>
              <CheckboxGroup v-model="warehouseIdList">
                <Row>
                  <Col span="8" v-for="(item,index) in ymsWarehouseData" :key="index">
                    <div class="flex align-items-center">
                      <Checkbox :label="item.ymsWarehouseId">{{ item.name }}</Checkbox>
                      <template v-if="showLogisticsBinding(item)">
                        <span class="ml4 font-size-12" :class="item.overseaShippingMethodId ? 'greenColor' : 'redColor'">{{ item.bindingText }}</span>
                        <span class="themeColor font-size-12 cursor ml6" @click="logisticsBindingBtn(item)">
                          {{ $t('key1000561') }}
                        </span>
                      </template>
                    </div>
                  </Col>
                </Row>
              </CheckboxGroup>
            </div>
            <div v-show="type === '02'">
              {{ $store.state.carrierName }}
            </div>
          </div>
        </Card>
        <!--平台标发货设置-->
        <Card class="set_card_style mb20" :bordered="true" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1005332') }}</h2>
          </template>
          <div class="flex modalItemBox" v-for="(platformItem,platformItemIndex) in platformGroup"
            :key="platformItem.platformId" style="max-height: 400px;overflow-y: auto;">
            <div class="platformTitle flex">
              <Checkbox @on-change="setCheckboxStatus($event,platformItemIndex)"
                v-model="platformItem.checkboxStatus">
                {{ platformItem.platformId }}
              </Checkbox>
            </div>
            <div style="width:100%; padding-bottom:10px" v-if="platformItem.checkboxStatus && shippingParams.platformCarrierSettings">
              <div v-for="(item, scIndex) in shippingParams.platformCarrierSettings[platformItem.platformId]" :key="scIndex">
                <div class="flex flex-wrap mt15 pl12" v-if="!item.hasOwnProperty('countryCode') || item.countryCode === null">
                  <Select v-model="shippingParams.platformCarrierSettings[platformItem.platformId][0].markDeliveryType" class="width_150">
                    <Option v-for="item in markDeliveryTypeList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                  </Select>
                  <FormItem :label="$t('key1005279')" prop="carrierCode" :label-width="150">
                    <Select class="width_180" v-if="carrierCodeArr[platformItem.platformId].length"
                      v-model.trim="item.carrierCode" filterable allow-create transfer
                      @on-create="(value) =>customizedLogisticsServiceProvider(value, platformItem.platformId)">
                      <Option v-for="(ccaItem, ccaIndex) in carrierCodeArr[platformItem.platformId]" :key="ccaIndex" :value="ccaItem.valueCode">
                        {{ ccaItem.valueCnName }}
                      </Option>
                    </Select>
                    <Input v-else v-model.trim="shippingParams.platformCarrierSettings[platformItem.platformId][0].carrierCode" class="width_200" :placeholder="$t('key1000324')"></Input>
                  </FormItem>
                  <FormItem :label="$t('key1005280')" :label-width="110" prop="deliveryCountryCode" v-if="platformItem.platformId === 'wish'">
                    <Select class="width_140" v-model="item.deliveryCountryCode" filterable>
                      <Option v-for="(item, index) in countrysData" :key="index" :value="item.twoCode" :v="item.cnName">{{ item.enName }}</Option>
                    </Select>
                  </FormItem>
                  <FormItem :label="$t('key1005281')" :label-width="110" prop="pickUpType" v-if="platformItem.platformId === 'tiktok'">
                    <Select class="width_140" v-model.trim="item.pickUpType" filterable>
                      <Option :value=1>Pick up</Option>
                      <Option :value=2>Drop off</Option>
                    </Select>
                  </FormItem>
                  <FormItem :label="$t('key1001521')" prop="trackingNumberType" :label-width="80">
                    <Select class="width_140" v-model="shippingParams.platformCarrierSettings[platformItem.platformId][0].trackingNumberType" transfer filterable>
                      <Option :value=0>{{ $t('key1005333') }}</Option>
                      <Option :value=1>{{ $t('key1004440') }}</Option>
                      <Option :value=2>{{ $t('key1003698') }}</Option>
                    </Select>
                  </FormItem>
                  <FormItem :label="$t('key1005282')" prop="shippingService" v-if="platformItem.platformId === 'amazon'">
                    <Select class="width_200" filterable allow-create @on-create="handleCreateDelivery"
                      v-model="shippingParams.platformCarrierSettings[platformItem.platformId][0].shippingService">
                      <Option v-for="item in amazonDeliveryList" :value="item.valueCode">{{ item.valueCnName }}</Option>
                    </Select>
                  </FormItem>
                  <div class="height_32 line_height_32 font-size-12">{{ $t('key1005334') }}</div>
                  <div v-if="!looKsettings" class="themeColor cursor line_height_32 font-size-12 height_32"
                    @click="addSpecialCountry(platformItem.platformId)">
                    {{ $t('key1005335') }}
                  </div>
                </div>
                <!--添加特例国家-->
                <template v-else>
                  <div class="flex flex-wrap p15">
                    <FormItem :label="$t('key1002677')"
                      prop="countryCode"
                      :rules="{
                      required: true,
                      validator: validCountryCode(scIndex, platformItem.platformId, platformItem.checkboxStatus),
                       trigger: 'change'}"
                      :label-width="80">
                      <Select class="width_150" filterable :placeholder="$t('key1001357')"
                        v-model="shippingParams.platformCarrierSettings[platformItem.platformId][scIndex].countryCode">
                        <Option v-for="(item,ccIndex) in countrysData" :key="ccIndex" :value="item.twoCode">{{ item.enName }}</Option>
                      </Select>
                    </FormItem>
                    <FormItem
                      :label="$t('key1005279')"
                      prop="carrierCode"
                      :rules="{
                      required: true,
                      validator: validCarrier(scIndex, platformItem.platformId, platformItem.checkboxStatus),
                       trigger: carrierCodeArr[platformItem.platformId].length ? 'change' : 'blur'}"
                      :label-width="170">
                      <Select
                        class="width_200"
                        v-if="carrierCodeArr[platformItem.platformId].length"
                        v-model.trim="shippingParams.platformCarrierSettings[platformItem.platformId][scIndex].carrierCode"
                        filterable allow-create @on-create="(value) =>customizedLogisticsServiceProvider(value, platformItem.platformId, 'specialCase', scIndex)">
                        <Option v-for="(ccaItem,ccaIndex) in carrierCodeArr[platformItem.platformId]" :key="ccaIndex" :value="ccaItem.valueCode">{{ ccaItem.valueCnName }}</Option>
                      </Select>
                      <Input v-else
                        v-model.trim="shippingParams.platformCarrierSettings[platformItem.platformId][scIndex].carrierCode"
                        class="width_200"
                        :placeholder="$t('key1000324')">
                      </Input>
                    </FormItem>
                    <FormItem :label="$t('key1005280')" :label-width="140" v-if="platformItem.platformId === 'wish'">
                      <Select
                        class="width_170"
                        v-model="shippingParams.platformCarrierSettings[platformItem.platformId][scIndex].deliveryCountryCode"
                        filterable>
                        <Option v-for="(item, index) in countrysData" :key="index" :value="item.twoCode" :v="item.cnName">{{ item.enName }}</Option>
                      </Select>
                    </FormItem>
                    <FormItem :label="$t('key1005281')" :label-width="110" v-if="platformItem.platformId === 'tiktok'">
                      <Select class="width_140" filterable
                        v-model.trim="shippingParams.platformCarrierSettings[platformItem.platformId][scIndex].pickUpType">
                        <Option :value=1>Pick up</Option>
                        <Option :value=2>Drop off</Option>
                      </Select>
                    </FormItem>
                    <FormItem :label="$t('key1001521')" prop="trackingNumberType" :label-width="78">
                      <Select v-model="shippingParams.platformCarrierSettings[platformItem.platformId][scIndex].trackingNumberType" class="width_150">
                        <Option :value=0>{{ $t('key1005333') }}</Option>
                        <Option :value=1>{{ $t('key1004440') }}</Option>
                        <Option :value=2>{{ $t('key1003698') }}</Option>
                      </Select>
                    </FormItem>
                    <span v-if="!looKsettings" class="redColor cursor redColor line_height_32 font-size-12 height_32 ml10"
                      @click="delShippingParamsItem(scIndex, platformItem.platformId)">{{ $t('key1000105') }}</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </Card>
        <!--渠道设置地址（线上）-->
        <Card class="set_card_style mb20" :bordered="true" dis-hover v-if="!ymsLogisticsChannelTalg && isOnline === 1">
          <template #title>
            <h2 class="title_box">{{ logisticsChannelModalParams.carrierShippingMethod.carrierName + $t('key1000669') }}</h2>
          </template>
          <Form ref="addressInfo" :model="addressInfo" :label-width="90" class="addressBoxStyle"
            :disabled="looKsettings" @submit.native.prevent>
            <template v-for="(item, idx) in addressInfo.carrierAccountAddressList">
              <!--寄件地址-->
              <Card v-if="item.addressType === 'sender'" :bordered="false" dis-hover :key="idx" class="addressStyle_item">
                <template #title>
                  <h2 class="title_center">{{ addressTypeName[item.addressType] }}</h2>
                </template>
                <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <Form-item :label="$t('key1002436')" :prop="`carrierAccountAddressList.${idx}.ymsAddressTemplateId`"
                    :rules="{required: true, message: $t('key1002432'),trigger: 'change'}">
                    <div class="flex align-items-center">
                      <Select
                        @on-change="(val)=>selectChange(val, item.addressType)"
                        @on-open-change="openChange"
                        v-model="addressInfo.carrierAccountAddressList[idx].ymsAddressTemplateId"
                        filterable
                        style="width: 210px;">
                        <Option v-for="(item, index) in addressTemplateData" :value="item.ymsAddressTemplateId" :label="item.addressName" :key="index">
                          <span v-html="item.templateName"></span>
                        </Option>
                      </Select>
                      <span class="cursor themeColor ml8 font-size-13" @click="addAddressTemplateBtn">{{ $t('key1000718') }}</span>
                    </div>
                  </Form-item>
                  <Row type="flex" :gutter="gutterItem" class="font-size-12 mt24" style="margin-left: 23px"
                    v-if="Object.keys(addressInfo.carrierAccountAddressList[idx].addressDetails).length >0">
                    <Col :span="24" class="basic_item" v-for="ele in addressInfoList">
                      <span class="basic_title">{{ ele.title + '：' }}</span>
                      <span class="basic_txt" :title="addressInfo.carrierAccountAddressList[idx].addressDetails[ele.paramsKey]">
                        {{ addressInfo.carrierAccountAddressList[idx].addressDetails[ele.paramsKey] || '--' }}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Card>
              <!--揽件人地址-->
              <Card :bordered="false" dis-hover :key="idx" class="addressStyle_item"
                v-if="apiInterface === 'API_EDIS' && item.addressType === 'pickup'">
                <template #title>
                  <h2 class="title_center">{{ addressTypeName[item.addressType] }}</h2>
                </template>
                <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <FormItem :label="$t('key1005283')" :prop="`carrierAccountAddressList.${idx}.edisShippingType`"
                    :rules="{type: 'number', required: true, message: $t('key1005274'), trigger: 'change'}">
                    <Select v-model.trim="addressInfo.carrierAccountAddressList[idx].edisShippingType"
                      filterable disabled>
                      <Option v-for="(talg,ids) in deliveryModeList" :key="ids" :value="talg.value">{{
                          talg.name
                        }}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <FormItem :label="$t('key1004123')" :prop="`carrierAccountAddressList.${idx}.edisPickupTime`"
                    :rules="{required: true, message: $t('key1005275'), trigger: 'change'}">
                    <Select v-model.trim="addressInfo.carrierAccountAddressList[idx].edisPickupTime" filterable>
                      <Option v-for="(talg,ids) in collectionTimeList" :key="ids" :value="talg.value">
                        {{ talg.name }}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <Form-item :label="$t('key1002436')" :prop="`carrierAccountAddressList.${idx}.ymsAddressTemplateId`"
                    :rules="{required: true, message: $t('key1002432'),trigger: 'change'}">
                    <div class="flex align-items-center">
                      <Select
                        @on-change="(val)=>selectChange(val, item.addressType)"
                        @on-open-change="openChange"
                        v-model="addressInfo.carrierAccountAddressList[idx].ymsAddressTemplateId"
                        filterable
                        style="width: 210px;">
                        <Option v-for="(item, index) in addressTemplateData" :value="item.ymsAddressTemplateId" :label="item.addressName" :key="index">
                          <span v-html="item.templateName"></span>
                        </Option>
                      </Select>
                      <span class="cursor themeColor ml8 font-size-13" @click="addAddressTemplateBtn">{{ $t('key1000718') }}</span>
                    </div>
                  </Form-item>
                  <Row type="flex" :gutter="gutterItem" class="font-size-12 mt24" style="margin-left: 23px"
                    v-if="Object.keys(addressInfo.carrierAccountAddressList[idx].addressDetails).length >0">
                    <Col :span="24" class="basic_item" v-for="ele in addressInfoList">
                      <span class="basic_title">{{ ele.title + '：' }}</span>
                      <span class="basic_txt" :title="addressInfo.carrierAccountAddressList[idx].addressDetails[ele.paramsKey]">
                        {{ addressInfo.carrierAccountAddressList[idx].addressDetails[ele.paramsKey] || '--' }}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Card>
              <!--退件人地址-->
              <Card v-if="item.addressType === 'return'" :bordered="false" dis-hover :key="idx"
                class="addressStyle_item">
                <template #title>
                  <h2 class="title_center">{{ addressTypeName[item.addressType] }}</h2>
                </template>
                <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <Form-item :label="$t('key1002436')" :prop="`carrierAccountAddressList.${idx}.ymsAddressTemplateId`"
                    :rules="{required: true, message: $t('key1002432'),trigger: 'change'}">
                    <div class="flex align-items-center">
                      <Select
                        @on-change="(val)=>selectChange(val, item.addressType)"
                        @on-open-change="openChange"
                        v-model="addressInfo.carrierAccountAddressList[idx].ymsAddressTemplateId"
                        filterable
                        style="width: 210px;">
                        <Option v-for="(item, index) in addressTemplateData" :value="item.ymsAddressTemplateId" :label="item.addressName" :key="index">
                          <span v-html="item.templateName"></span>
                        </Option>
                      </Select>
                      <span class="cursor themeColor ml8 font-size-13" @click="addAddressTemplateBtn">{{ $t('key1000718') }}</span>
                    </div>
                  </Form-item>
                  <Row type="flex" :gutter="gutterItem" class="font-size-12 mt24" style="margin-left: 23px"
                    v-if="Object.keys(addressInfo.carrierAccountAddressList[idx].addressDetails).length >0">
                    <Col :span="24" class="basic_item" v-for="ele in addressInfoList">
                      <span class="basic_title">{{ ele.title + '：' }}</span>
                      <span class="basic_txt" :title="addressInfo.carrierAccountAddressList[idx].addressDetails[ele.paramsKey]">
                        {{ addressInfo.carrierAccountAddressList[idx].addressDetails[ele.paramsKey] || '--' }}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Card>
            </template>
          </Form>
        </Card>
        <!--自定义物流不展示-->
        <!--面单打印设置-->
        <Card class="set_card_style mb20" :bordered="true" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1005336') }}</h2>
          </template>
          <div v-if="shippingData && shippingData.carrierParams">
            <template v-for="(item, cpIndex) in shippingData.carrierParams">
              <div class="flex justify-content-start" v-if="item" :key="cpIndex">
                <template v-if="item.paramKey === 'labelSize'">
                  <FormItem :label="$t('key1005284')" prop="paramValue">
                    <Select v-model="shippingData.carrierParams[cpIndex].paramValue" filterable>
                      <Option
                        v-if="item.carrierParamDictionaryList.length > 0"
                        v-for="(subItem,subIndex) in item.carrierParamDictionaryList"
                        :key="subIndex"
                        :value="subItem.itemValue">
                        {{ subItem.itemName }}
                      </Option>
                    </Select>
                  </FormItem>
                </template>
                <template v-if="item.paramKey === 'labelGenerrateType'">
                  <FormItem :label="$t('key1005285')" prop="paramValue">
                    <Select v-model="shippingData.carrierParams[cpIndex].paramValue" filterable>
                      <Option
                        v-if="item.carrierParamDictionaryList.length > 0"
                        v-for="(subItem,subIndex) in item.carrierParamDictionaryList"
                        :key="subIndex"
                        :value="subItem.itemValue">
                        {{ subItem.itemName }}
                      </Option>
                    </Select>
                  </FormItem>
                </template>
              </div>
            </template>
          </div>
          <div class="normalPadding flex">
            <Checkbox v-model="shippingParams.isPrintPickingList" :true-value="1" :false-value="0"
              style="margin:7px">
              {{ $t('key1005337') }}
            </Checkbox>
          </div>
        </Card>
      </Form>
      <template #footer>
        <Button v-if="!looKsettings" @click="setShippingMethod" :loading="buttonTalg" type="primary">{{ $t('key1000555') }}</Button>
        <Button @click="cancelBtn">{{ $t('key1000248') }}</Button>
      </template>
    </Modal>
    <!-- 编辑/查看运费 -->
    <billingModelEditingModal
      ref="billingModelEditing"
      @saveBtn="editOK"
      :looKsettings="looKsettings"
      :freightCurrency="freightCurrency">
    </billingModelEditingModal>
    <!--批量导入 计费模型-->
    <importFreightTemplateModal
      ref="importFreightTemplate"
      sourceType="basicLogistics"
      :uploadZoneExcel="uploadZoneExcel"
      @updateImportFreightTemplateData="importFreightTemplateSuccess">
    </importFreightTemplateModal>
    <!--从其他渠道引用-弹窗-->
    <channelReferenceModal ref="channelReference" @saveChannel="saveChannel"></channelReferenceModal>
    <!--3PL物流渠道绑定弹窗-->
    <logisticsBindingModal
      ref="logisticsBinding"
      @updateBindingInfo="updateBindingInfo"
      @updateLogisticsBinding="updateLogisticsBinding">
    </logisticsBindingModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import publicService from '@/components/mixin/publicService_mixin';
import importFreightTemplateModal from "@/components/common/importFreightTemplateModal";
import channelReferenceModal from "@/components/common/channelReferenceModal";
import billingModelEditingModal from "@/components/common/billingModelEditingModal";
import languagesTabs from "@/components/common/languagesTabs.vue";
import logisticsBindingModal from "@/components/common/logisticsBindingModal.vue";
import {publicExceptionCodes} from "@/config/exceptionCode";
import {
  _handleMultilingualFields,
  amountHandel, formatterNumber, getAllCountrysData, getAllYmsWarehouseData, getCurrencyData,
  getDataSetBatchList, getEnabledPlatforms, getEnumList, getEnumName, getRegionalRcountriesData,
  isValueEmpty, processFreightText, toNumber, toPercent, mergeByCountriesStrict
} from "@/utils/common";
import {PERFORMANCEMETHODDATA, THIRD_PARTY_WAREHOUSE} from "@/utils/enum";

export default {
  mixins: [Mixin, publicService],
  props: {
    accept: {
      type: Number,
      default: 0
    }
  },
  data() {
    let self = this;
    return {
      selectLoading: false,
      searchTimer: null,
      platformGroup: [],
      type: '01',
      looKsettings: false,
      logisticsChannelModal: false,
      logisticsChannelTitle: '',
      uploadZoneExcel: api.post_carrierShippingMethodPriceModelZone_importExcel,
      openType: 'look',
      buttonTalg: false,
      YesOrNolist: [
        {value: 1, label: 'Y'},
        {value: 0, label: 'N'}
      ],
      shippingMethodId: null,
      skuList: '',
      data4: [],
      data5: [
        {
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': '0',
          carrierShippingMethodPriceModelZoneCountryList: []
        }
      ], // 全球可达（运费相同）
      data6: [
        {
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': '0',
          carrierShippingMethodPriceModelZoneCountryList: []
        }
      ], // 全球可达（运费不同）
      data7: [], // 非全球可达
      // 计费模型币种
      freightCurrency: 'CNY',
      freightDiscount: 1,
      freightDiscountType: '1',
      columns4: [
        {
          key: 'zoneName',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005239'),
          align: 'center',
          render(h, params) {
            if (params.row.zoneName === '0') {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005240'));
            } else {
              return h('div', params.row.zoneName);
            }
          }
        }, {
          key: 'carrierShippingMethodPriceModelZoneCountryList',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005241'),
          align: 'center',
          render(h, params) {
            let text = '';
            if (params.row.zoneName === '0') {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005242'));
            } else {
              if (params.row.carrierShippingMethodPriceModelZoneCountryList) {
                text = params.row.carrierShippingMethodPriceModelZoneCountryList.map(i => {
                  return i.cnName;
                }).join('、');
              }
              return h('span', text);
            }
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005243'),
          align: 'center',
          render(h, params) {
            let priceType = params.row.priceType;
            let text = getEnumName(self.enumData, 'YmsLogisServicePriceModelZonePriceTypeCoreEnum', priceType, 'number');
            return h('span', text);
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005244'),
          align: 'center',
          render(h, params) {
            let weightType = params.row.weightType;
            let text = getEnumName(self.enumData, 'YmsLogisServicePriceModelZoneWeightTypeCoreEnum', weightType, 'number');
            return h('span', text);
          }
        },
        {
          key: 'formula',
          align: 'center',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005245'),
          render: (h, params) => {
            return h('span', {
              domProps: {
                innerHTML: params.row.formula || ''
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          width: 120,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                align: 'center',
                operationList: [
                  {
                    text: self.openType === 'look' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: true,
                    clickFn: () => {
                      self.editIndex = params.index;
                      self.$refs['billingModelEditing'].initBillingModelData(params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: params.row.zoneName !== '0' && self.openType !== 'look',
                    clickFn: () => {
                      self.data4.splice(params.index, 1);
                      // 全球可达（运费不同）
                      if (self.arriveableType === 2) {
                        self.data6.splice(params.index, 1);
                      }
                      // 非全球可达
                      else if (self.arriveableType === 3) {
                        self.data7.splice(params.index, 1);
                      }
                      self.data4.forEach((i, index) => {
                        if (self.arriveableType === 3) {
                          i.zoneName = index + 1 + '';
                        } else {
                          i.zoneName = index + '';
                        }
                      });
                    }
                  }
                ]
              }
            });
          }
        }
      ],
      checkAll: false,
      warehouseIdList: [],
      indeterminate: false,
      showMarkShipping: false,
      markDeliveryTypeList: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005246'), value: 0},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005247'), value: 1},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005248'), value: 2},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005249'), value: 3}
      ],
      carrierCodeArr: null,
      showAgentList: [],
      arriveableType: null,
      logisticsChannelModalParams: {
        acceptableCityList: null,
        acceptablePackageTypeList: [],
        carrierShippingMethod: {
          carrierShippingMethodCode: '',
          logisticsInterface: '',
          shipCompanyId: '',
          minEfficiency: 0,
          maxEfficiency: 0,
          isInsurance: 0,
          maxLength: 0,
          maxWidth: 0,
          maxHeight: 0,
          minWeight: 0,
          maxWeight: 0,
          maxPerimeter: 0,
          maxDimensionsLength: 0,
          minVolume: 0,
          maxVolume: 0,
          acceptablePackageTypeList: '',
          hasTrackingNumber: '',
          logisType: '',
          isSupportInterfaceTransferBill: 0,
          isRequiredConfirm: 0,
          arriveableType: '1',
          performanceType: 1
        }
      },
      shippingParams: { // 平台标发货设置
        shippingMethodId: '',
        shippingData: null,
        platformCarrierSettings: null,
        isPrintPickingList: 0
      },
      shippingData: null,
      shippingMethodIdCopy: null,
      saleAccountIdCopy: null, // 派送范围及运费
      pricingParams: {
        priceType: null,
        weightType: null,
        subCostWay: null
      },
      pricingModelCommonColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005239'),
          key: 'name',
          minWidth: 100,
          align: 'center'
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005241'),
          key: 'reachState',
          minWidth: 150,
          maxWidth: 240,
          align: 'center',
          render: (h, params) => {
            return h('div', self.getPricingReachStateData(params.row.carrierShippingMethodPriceModelZoneCountryList));
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697'),
          key: 'costPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  value: params.row.price,
                  min: 0,
                  max: 9999999,
                  placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005231')}`
                }
              }), h('div', {
                class: 'flex mt20 flexBoxJustContent'
              }, [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                  class: 'redColor'
                }, '$ ' + params.row.price * (self.freightDiscount === null ? 100 : self.freightDiscount) / 100)
              ])
            ]);
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001023'),
          key: 'registrationFee',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.registrationFee,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001023')}`
              }
            });
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005232'),
          key: 'operatingCost',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.operatingCost,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005232')}`
              }
            });
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027'),
          key: 'additionalFeeRate',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.additionalFeeRate,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027')}`
              }
            });
          }
        }
      ],
      pricingModelContinuedHeavyColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005233'),
          key: 'firstWeight',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.firstWeight,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005233')}`
              },
              on: {
                'input': (val) => {
                  self.cachePricingData[params.index].firstWeight = val;
                }
              }
            });
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001017'),
          key: 'firstWeightPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  value: params.row.firstWeightPrice,
                  min: 0,
                  max: 9999999,
                  placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001017')}`
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].firstWeightPrice = val;
                  }
                }
              }), h('div', {
                class: 'flex mt20 flexBoxJustContent'
              }, [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                  class: 'redColor'
                }, '$ ' + params.row.firstWeightPrice * (self.freightDiscount === null
                  ? 100
                  : self.freightDiscount) / 100)
              ])
            ]);
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005234'),
          key: 'unitWeight',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.unitWeight,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005234')}`
              },
              on: {
                'input': (val) => {
                  self.cachePricingData[params.index].unitWeight = val;
                }
              }
            });
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005235'),
          key: 'unitWeightPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  value: params.row.unitWeightPrice,
                  min: 0,
                  max: 9999999,
                  placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005235')}`
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].unitWeightPrice = val;
                  }
                }
              }), h('div', {
                class: 'flex mt20 flexBoxJustContent'
              }, [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                  class: 'redColor'
                }, '$ ' + params.row.unitWeightPrice * (self.freightDiscount === null
                  ? 100
                  : self.freightDiscount) / 100)
              ])
            ]);
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027'),
          key: 'additionalFeeRate',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.additionalFeeRate,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027')}`
              }
            });
          }
        }
      ],
      pricingModelColumns: [],
      cachePriceModelColumns: [],
      shippingLoading: true,
      carrierShippingMethodParmas: {
        maxPrice: null,
        minPrice: 0,
        maxLength: 0,
        minLength: 0,
        maxShippingFeeIncome: null,
        minShippingFeeIncome: 0,
        minEfficiency: 0,
        maxEfficiency: 0,
        minGoodsQuantity: 0,
        maxGoodsQuantity: null
      },
      modalData: {},
      isOnline: 0, // 1 线上物流  0 线下物流
      apiInterface: '',
      addressList: [
        {
          addressType: 'sender',
          addressDetails: {}
        },
        {
          addressType: 'pickup',
          edisPickupTime: 'TIME_14_16', // 揽收时间
          edisShippingType: 1, // 交运方式  1上门揽收 2卖家自送
          addressDetails: {}
        },
        {
          addressType: 'return',
          addressDetails: {}
        }
      ], // 寄件人、揽收人、退件人的模板信息
      addressInfo: {
        carrierAccountAddressList: []
      },
      addressTypeName: {
        sender: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005251'),
        pickup: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005252'),
        return: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005253')
      },
      deliveryModeList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005254')}
      ],
      collectionTimeList: [
        {value: 'TIME_14_16', name: '14:00-16:00'},
        {value: 'TIME_16_18', name: '16:00-18:00'}
      ],
      ymsLogisticsChannelTalg: false, // 默认以基础物流的形式展示  true 以只有物流的形式展示
      deliveryMethodForm: {
        domesticExpressFee: null, // 国内快递费用
        deliveryType: 2, // 交货方式
        deliveryAddressType: 1, // 国内快递收货地址选择
        carrierShippingMethodAddressId: null,
        ymsAddressTemplateId: null,
        addressDetails: {}
      },
      ruleValidate: {
        domesticExpressFee: [{type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005255'), trigger: 'change'}],
        ymsAddressTemplateId: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002432'), trigger: 'change'}]
      },
      addressTalg: true,
      addressInfoList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002331'), paramsKey: 'name'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002332'), paramsKey: 'countryCode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002333'), paramsKey: 'state'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002334'), paramsKey: 'city'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002335'), paramsKey: 'district'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002336'), paramsKey: 'street'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002337'), paramsKey: 'street2'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002338'), paramsKey: 'street3'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002339'), paramsKey: 'phone'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002340'), paramsKey: 'postcode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002341'), paramsKey: 'company'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'), paramsKey: 'email'},
      ],
      amazonDeliveryList: [],
      logisticsCarrierData: [],
      originalData: [],
      pages: {
        nameCn: '',
        trackingMoreCarrierCodeIds: [],
        type: null,
        pageNum: 1,
        pageSize: 15
      },
      isScroll: true, //是否可以滚动
      showMore: true, // 是否有更多数据
      logisticsCarrier: null,
      logisticsCarrierName: '',
      carrierCode: null,

      infinite: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000836'),
      isCollectCancel: 0, // 是否收取此费用
      collectCancelType: 2, // 费用收取方式
      currencySystem: 'CNY', // 计费币种
      feeCollectionConfigList: [
        {
          minHour: null,
          maxHour: null,
          invalidFees: null,
          logisticsFee: null,
          currency: 'CNY',
          startErrorText: '',
          endErrorText: '',
          priceText: '',
          errorText: '',
          disabled: false,
        }
      ],
      currencyList: [],
      ymsWarehouseData: [],
      verificationTalg: true,
      apiType: 0, // 物流商类型 0:自营仓物流商   1:海外仓物流商
      countrysData: [],
      enumData: [],
    };
  },
  computed: {
    freightCurrencyText() {
      let text = '';
      if (this.currencyList.length > 0) {
        this.currencyList.map((item) => {
          if (item.value === this.freightCurrency) {
            text = item.label;
          }
        });
      }
      return text;
    },
    currencySystemText() {
      let text = '';
      if (this.currencyList.length > 0) {
        this.currencyList.map((item) => {
          if (item.value === this.currencySystem) {
            text = item.label;
          }
        });
      }
      return text;
    },
    arriveableTypeText() {
      return getEnumName(this.enumData, 'YmsLogisServiceArriveableTypeCoreEnum', this.arriveableType, 'number');
    },
    freightDiscountTypeList() {
      const ENUM_KEY = 'YmsLogisServicePriceModelFreightDiscountTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY);
    },
    // 派送范围
    sendUsageTypeList() {
      const ENUM_KEY = 'YmsLogisServiceArriveableTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    // 交货方式
    deliveryMethodList() {
      const ENUM_KEY = 'DeliveryTypeEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    // 履约方式
    performanceMethodlist() {
      let list = [];
      if (this.carrierCode === 'tiktok') {
        list = PERFORMANCEMETHODDATA;
      } else {
        list = PERFORMANCEMETHODDATA.filter(item => item.value !== 2);
      }
      return list;
    }
  },
  methods: {
    formatterNumber,
    isValueEmpty,
    getEnumName,
    // 初始化数据
    async initLogisticsChannelData(type, shippingMethodId, index) {
      let v = this;
      let enumKeyList = [
        'YmsLogisServicePriceModelZoneWeightTypeCoreEnum',
        'YmsLogisServicePriceModelZonePriceTypeCoreEnum',
        'YmsLogisServicePriceModelFreightDiscountTypeCoreEnum',
        'YmsLogisServiceArriveableTypeCoreEnum',
        'DeliveryTypeEnum'
      ];
      v.enumData = await getDataSetBatchList(enumKeyList);
      getAllCountrysData().then((data) => {
        v.countrysData = data;
        v.getAddressTemplateData();
        getCurrencyData().then((currencyData) => {
          v.currencyList = currencyData;
        });
        v.getLogisticsCarrierData();
        let titleObj = {
          edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005256'),
          look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005257'),
          addCustom: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005220'),
          copy: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005258'),
        };
        v.$refs['languagesTab'].tabName = v.languagesVal;
        let keyList = ['carrierShippingMethodName_', 'remark_'];
        v.initMultilingualFields('logisticsChannelModalParams.carrierShippingMethod', v.logisticsChannelModalParams.carrierShippingMethod, keyList).then((obj) => {
          v.logisticsChannelTitle = titleObj[type];
          v.ymsLogisticsChannelTalg = false;
          v.openType = type;
          v.logisticsChannelModalParams.carrierShippingMethod = obj;
          if (type === 'look') {
            v.looKsettings = true;
          } else {
            v.looKsettings = false;
          }
          if (type === 'addCustom') {
            v.data4 = JSON.parse(JSON.stringify(this.data5));
            v.warehouseIdList = [];
            v.resetData();
            v.setShopGroup(this.shopList, []);
            v.logisticsChannelModalParams.carrierShippingMethod.carrierName = this.$store.state.formInlineInfo.carrierName || '';
            // 获取仓库列表
            getAllYmsWarehouseData().then((data) => {
              let carrierCodeList = ['temuHalfTl', 'tiktok'];
              if (carrierCodeList.includes(v.carrierCode)) {
                v.ymsWarehouseData = data;
              } else {
                v.ymsWarehouseData = data.filter((item) => !item.apiCode);
              }
            });
            v.makePlatformGroup();
            v.makeCarrierCode();
            v.handleDefaultAddressData();
            v.logisticsChannelModal = true;
          }
          v.showShippingSetting(shippingMethodId, index);
        });
      });
    },
    // 获取国家的数据
    getAllCountryName(loading) {
      let v = this;
      getRegionalRcountriesData(loading).then((data) => {
        v.$refs['billingModelEditing'].countryCodesName = data;
      });
    },
    // 设置/编辑/新增自定义物流渠道弹窗---显示状态发生变化时触发的事件
    visible2(open) {
      if (!open) {
        this.resetAllData();
      }
    },
    // 重置所有数据
    resetAllData() {
      let v = this;
      v.verificationTalg = true;
      v.shippingParams.isPrintPickingList = 0;
      v.carrierShippingMethodPriceModelId = null;
      v.data5 = [
        {
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': '0',
          carrierShippingMethodPriceModelZoneCountryList: []
        }
      ];
      v.data6 = [
        {
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': '0',
          carrierShippingMethodPriceModelZoneCountryList: []
        }
      ];
      v.data7 = [];
      v.arriveableType = 1;
      v.$refs['deliveryMethodForm'].resetFields();
      v.deliveryMethodForm.carrierShippingMethodAddressId = null;
      v.deliveryMethodForm.addressDetails = {};
      v.addressInfo = {
        carrierAccountAddressList: []
      };
      v.addressTalg = true;
      v.addressList = [
        {
          addressType: 'sender',
          addressDetails: {}
        },
        {
          addressType: 'pickup',
          edisPickupTime: 'TIME_14_16',
          edisShippingType: 1,
          addressDetails: {}
        },
        {
          addressType: 'return',
          addressDetails: {}
        }
      ];
      v.isOnline = 0;
      v.infinite = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000836');
      v.isCollectCancel = 0;
      v.collectCancelType = 2;
      v.currencySystem = 'CNY';
      v.feeCollectionConfigList = [
        {
          minHour: null,
          maxHour: null,
          invalidFees: null,
          logisticsFee: null,
          currency: 'CNY',
          startErrorText: '',
          endErrorText: '',
          priceText: '',
          errorText: '',
          disabled: false,
        }
      ];
      v.resetData();
    },

    // 从其他渠道引用
    channelCitation() {
      this.$refs.channelReference.channelModal = true;
      let selectProvider = this.modalData.carrier.carrierId;
      this.$refs.channelReference.selectProvider = selectProvider;
      this.$refs.channelReference.logisticsChannel = this.modalData.carrierShippingMethod.shippingMethodId;
      this.$refs.channelReference.ChangeSelectProvider(selectProvider);
    },

    // 新增分区
    addPartition() {
      if (this.arriveableType === 2) {
        let lenght = this.data6.length + '';
        if (this.data4.length > 0) {
          this.data6 = JSON.parse(JSON.stringify(this.data4));
        }
        this.data6.push({
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': lenght,
          carrierShippingMethodPriceModelZoneCountryList: []
        });
        this.data4 = JSON.parse(JSON.stringify(this.data6));
      } else if (this.arriveableType === 3) {
        let lenght = this.data7.length + 1 + '';
        if (this.data4.length > 0) {
          this.data7 = JSON.parse(JSON.stringify(this.data4));
        }
        this.data7.push({
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': lenght,
          carrierShippingMethodPriceModelZoneCountryList: []
        });
        this.data4 = JSON.parse(JSON.stringify(this.data7));
      }
    },

    // 添加特例国家
    addSpecialCountry(platformId) {
      let v = this;
      let obj = {
        carrierCode: '',
        countryCode: '',
        platformId: platformId,
        trackingNumberType: 0,
        markDeliveryType: 0
      };
      if (platformId === 'wish') {
        obj.deliveryCountryCode = '';
      }
      if (platformId === 'tiktok') {
        obj.pickUpType = null;
      }
      v.shippingParams.platformCarrierSettings[platformId].push(obj);
    },

    // 删除--单个平台标发货设置
    delShippingParamsItem(index, platformId) {
      let v = this;
      v.shippingParams.platformCarrierSettings[platformId].splice(index, 1);
    },

    // 判断是否有选中---平台标发货设置
    getNewShippingParamsObj(obj) {
      let arr = [];
      let v = this;
      return new Promise(resolve => {
        let len = Object.keys(obj.platformCarrierSettings).length;
        for (let item in obj.platformCarrierSettings) {
          len--;
          obj.platformCarrierSettings[item].forEach((n, i) => {
            v.platformGroup.forEach((m, t) => { // 如果勾选了
              if (n.platformId === m.platformId && m.checkboxStatus) {
                arr.push(n);
              }
            });
          });
          if (len === 0) {
            resolve(arr);
          }
        }
        if (len === 0) {
          resolve();
        }
      });
    },
    // 设置/编辑自定义物流渠道--保存按钮
    setShippingMethod(tApi) {
      /**
       * tApi 接口
       * */
      let v = this;
      let talg = true;
      let pos = [];
      let feeCollectionConfigTalg = true;
      let carrierShippingMethodCanceledPricList = [];
      for (let j = 0; j < v.multilingualNamesList.length; j++) {
        let ele = v.multilingualNamesList[j];
        if (!v.logisticsChannelModalParams.carrierShippingMethod['carrierShippingMethodName_' + ele.code] && ele.code === 'zh-CN') {
          v.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000222')}${ele.title}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002427')}`);
          return false;
        }
      }
      if (!v.logisticsChannelModalParams.carrierShippingMethod.carrierShippingMethodCode) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005259'));
        return;
      }
      if (v.carrierCode === 'temuHalfTl') {
        if (!v.logisticsChannelModalParams.carrierShippingMethod.logisticsInterface) {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005260'));
          return;
        }
        if (!v.logisticsChannelModalParams.carrierShippingMethod.shipCompanyId) {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005261'));
          return;
        }
      }
      // 线上物流
      if (v.isOnline === 1) {
        if (!v.logisticsChannelModalParams.carrierShippingMethod.performanceType) {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005262'));
          return;
        }
      }

      let shippingParams = v.handleSubmit('shippingParams');
      if (!shippingParams) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000364'));
        return false;
      }
      let addressInfo = true;
      if (v.isOnline === 1) {
        addressInfo = v.handleSubmit('addressInfo');
      }
      // 校验物流费配置
      if (v.isCollectCancel === 1) {
        let keyList = ['left', 'right', 'price'];
        v.feeCollectionConfigList.map((item, index) => {
          keyList.map((key) => {
            v.verificationInterval(item, index, key);
          });
          let price = v.collectCancelType === 2 ? Number(amountHandel(item.invalidFees)) : toNumber(item.logisticsFee, 4);
          carrierShippingMethodCanceledPricList.push({
            endTime: item.maxHour ? item.maxHour : index === v.feeCollectionConfigList.length - 1 ? 9999999 : null,
            price: price,
            startTime: item.minHour,
            priceCurrency: item.currency,
          });
        });
        feeCollectionConfigTalg = v.feeCollectionConfigList.every((ele) => {
          return !ele.startErrorText && !ele.endErrorText && !ele.priceText && !ele.errorText;
        });
      }
      if (!feeCollectionConfigTalg) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005263'));
        return false;
      }
      let warehouseBos = [];
      // 适用仓库
      if (v.ymsWarehouseData.length > 0) {
        v.warehouseIdList.map((val) => {
          v.ymsWarehouseData.map((item) => {
            if (val === item.ymsWarehouseId) {
              warehouseBos.push({
                warehouseId: val,
                overseaShippingMethodId: item.overseaShippingMethodId
              });
            }
          });
        });
      }


      if (shippingParams && addressInfo) {
        let obj = v.deepCopy(v.shippingParams);
        v.getNewShippingParamsObj(obj).then(result => {
          obj.platformCarrierSettings = result || [];
          obj.carrierShippingMethodPriceModel = {};
          obj.carrierShippingMethodPriceModel.priceType = v.pricingParams.priceType;
          obj.carrierShippingMethodPriceModel.weightType = v.pricingParams.weightType;
          obj.carrierShippingMethodPriceModel.freightDiscount = v.freightDiscount;
          obj.carrierShippingMethodPriceModel.freightCurrency = v.freightCurrency;
          obj.carrierShippingMethodPriceModel.freightDiscountType = v.freightDiscountType;
          obj.carrierShippingMethodPriceModel.carrierShippingMethodPriceModelId = v.carrierShippingMethodPriceModelId;
          obj.carrierShippingMethodPriceModelZoneList = v.data4;
          obj.updateApplicationScopeBo = {
            goodsTagList: v.goodsTagList,
            maxGoodsQuantity: v.carrierShippingMethodParmas.maxGoodsQuantity,
            maxPrice: v.carrierShippingMethodParmas.maxPrice,
            maxShippingFeeIncome: v.carrierShippingMethodParmas.maxShippingFeeIncome,
            minGoodsQuantity: v.carrierShippingMethodParmas.minGoodsQuantity,
            minPrice: v.carrierShippingMethodParmas.minPrice,
            minShippingFeeIncome: v.carrierShippingMethodParmas.minShippingFeeIncome,
            skuList: v.skuList.length > 0 ? v.skuList.split(/[ |,]/) : [],
            warehouseBos: warehouseBos
            // warehouseIdList: v.warehouseIdList,
          };
          obj.isCollectCancel = v.isCollectCancel;
          obj.collectCancelType = v.isCollectCancel === 0 ? 2 : v.collectCancelType;
          obj.arriveableType = v.arriveableType; // 邮寄方式  可达类型(1全球可达运费相同2全球可达运费不同3非全球可达) ,
          if (obj.carrierShippingMethodPriceModelZoneList) {
            let valid = obj.carrierShippingMethodPriceModelZoneList.some(i => {
              return i.zoneName !== '0' && (!i.countryTwoCodeList || i.countryTwoCodeList.length === 0);
            });
            if (valid) {
              v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005264'));
              return;
            }

            obj.carrierShippingMethodPriceModelZoneList.forEach((n, i) => {
              if (n.carrierShippingMethodSectionChargesList) {
                n.carrierShippingMethodSectionChargesList.forEach((m, t) => {
                  pos.push(m);
                });
              }
            });
          }
          obj.carrierShippingMethodSectionCharges = pos;
          // 物流费配置
          if (v.isCollectCancel === 1) {
            obj.carrierShippingMethodCanceledPriceBos = carrierShippingMethodCanceledPricList;
          } else {
            obj.carrierShippingMethodCanceledPriceBos = [];
          }
          /* 添加基础信息 */
          let keyList = ['carrierShippingMethodName_', 'remark_'];
          let params = v.handleMultilingualMultipleParam(v.logisticsChannelModalParams.carrierShippingMethod, keyList);
          obj.baseDetail = params;
          obj.baseDetail.acceptablePackageTypeList = v.logisticsChannelModalParams.acceptablePackageTypeList;
          obj.baseDetail.receiveTypeList = [];
          obj.baseDetail.arriveableType = v.arriveableType; // 邮寄方式  可达类型(1全球可达运费相同2全球可达运费不同3非全球可达)
          obj.baseDetail.isPrintPickingList = v.shippingParams.isPrintPickingList;

          if (['addCustom', 'copy'].includes(v.openType)) {
            obj.carrierId = v.$store.state.formInlineInfo.carrierId;
            delete obj.shippingMethodId;
          }
          // 渠道地址信息
          let newList = [];
          let carrierAccountAddressList = JSON.parse(JSON.stringify(v.addressInfo.carrierAccountAddressList));
          if (carrierAccountAddressList.length > 0) {
            carrierAccountAddressList.map((item) => {
              let {addressDetails, ...obj} = item;
              newList.push(obj);
            });
          }
          obj.carrierShippingMethodAddress = newList;
          // 承运方
          let haulier = '';
          obj.logisticsCarrier = v.logisticsCarrier;
          v.logisticsCarrierData.map((item) => {
            if (item.nameCn === v.logisticsCarrier) {
              haulier = item.name;
            }
          });
          obj.haulier = haulier;

          // 处理交货方式的参数
          function handleDeliveryMethodForm(obj, params) {
            const {deliveryType, domesticExpressFee, deliveryAddressType, ymsAddressTemplateId, carrierShippingMethodAddressId} = params;
            // 基础赋值
            if (['addCustom', 'copy'].includes(v.openType)) {
              Object.assign(obj, {deliveryType, deliveryAddressType});
              obj.baseDetail.domesticExpressFee = domesticExpressFee;
            } else {
              Object.assign(obj, {deliveryType, domesticExpressFee, deliveryAddressType});
            }
            const list = obj.carrierShippingMethodAddress || (obj.carrierShippingMethodAddress = []);
            const data = {
              addressType: 'delivery',
              deliveryType,
              edisShippingType: 0,
              ymsAddressTemplateId,
              carrierShippingMethodAddressId
            };
            const item = list.find(i => i.addressType === 'delivery');
            item ? Object.assign(item, data) : list.push(data);

            return obj;
          }

          // 新增
          let apiUrl = '';
          let method = '';
          if (['addCustom', 'copy'].includes(v.openType)) {
            apiUrl = api.ymsCarrierShippingMethod_addDefine;
            method = 'post';
          }
          // 编辑
          else {
            apiUrl = api.set_carrierShippingMethod;
            method = 'put';
          }
          if (v.deliveryMethodForm.deliveryType === 1) {
            if (v.deliveryMethodForm.deliveryAddressType === 1) {
              v.$refs['deliveryMethodForm'].validate((valid) => {
                talg = valid;
              });
            } else {
              if (!v.deliveryMethodForm.domesticExpressFee) {
                v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005255'));
                talg = false;
              }
            }
          }
          if (talg) {
            v.buttonTalg = true;
            let query = handleDeliveryMethodForm(obj, v.deliveryMethodForm);
            v.axios[method](apiUrl, JSON.stringify(query), {loading: true}).then(response => {
              v.buttonTalg = false;
              v.verificationTalg = false;
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
                v.logisticsChannelModal = false;
                v.resetShippingData();
                v.resetData();
                v.$emit('updateData', true);
              } else {
                v.shippingLoading = false;
                v.$nextTick(function () {
                  v.shippingLoading = true;
                });
              }
            });
          }
        });
      }
    },

    // 选中--全部自营仓库
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      if (this.checkAll) {
        this.warehouseIdList = [];
        this.ymsWarehouseData.map(i => {
          this.warehouseIdList.push(i.ymsWarehouseId);
        });
      } else {
        this.warehouseIdList = [];
      }
    },

    // 选中--平台标发货设置
    setCheckboxStatus(value, index) {
      let v = this;
      delete v.platformGroup[index].checkboxStatus;
      v.$set(v.platformGroup[index], 'checkboxStatus', value);
      v.showMarkShipping = false;
      v.$nextTick(function () {
        v.showMarkShipping = true;
      });
    },

    // 校验国家
    validCountryCode(index, platformId, status) {
      let v = this;
      return function (rule, value, callback) {
        if (status && !v.shippingParams.platformCarrierSettings[platformId][index].countryCode) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005236')));
        } else {
          callback();
        }
      };
    },
    // 校验物流商服务
    validCarrier(index, platformId, status) {
      let v = this;
      return function (rule, value, callback) {
        if (status && !v.shippingParams.platformCarrierSettings[platformId][index].carrierCode) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005237')));
        } else {
          callback();
        }
      };
    },

    // 计费模型编辑弹窗--保存按钮
    editOK(obj) {
      let v = this;
      if (obj) {
        v.data4[v.editIndex].carrierShippingMethodSectionChargesList = obj.cacheEditPriceModalData;
        v.data4[v.editIndex].volumeWeight = obj.pricingQuantityMode.volumeWeight;
        v.data4[v.editIndex].weightType = obj.pricingQuantityMode.weightType;
        v.data4[v.editIndex].priceType = obj.pricingQuantityMode.priceType;
        v.data4[v.editIndex].formula = obj.freightText;
        v.data4[v.editIndex].countryTwoCodeList = obj.choseCountryId;
        v.data4[v.editIndex].carrierShippingMethodPriceModelZoneCountryList = obj.countryData.filter(i => {
          if (obj.choseCountryId.indexOf(i.twoCode) > -1) {
            return i;
          }
        });
        let data = JSON.parse(JSON.stringify(v.data4));
        v.data4 = [];
        v.data4 = data;
      }
    },

    // 导入运费模板批量上传文件成功
    importFreightTemplateSuccess(res) {
      const v = this;
      if (res.data.code !== 0) {
        const text = publicExceptionCodes(res.data.code);
        const errorMsg = text || aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005265');
        v.$Message.error(errorMsg);
        return false;
      }
      v.$refs['importFreightTemplate'].importFreightTemplateModal = false;
      v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251'));
      // 2 覆盖原有数据, 1 国家相同覆盖不同追加
      const coveredType = res.coveredType;
      let data = res.data.datas.carrierShippingMethodPriceModelZones || [];
      const countryMap = new Map((v.countrysData || []).map(country => [country.twoCode, country]));
      data.forEach(i => {
        const zoneCountryList = i.carrierShippingMethodPriceModelZoneCountryList || [];
        zoneCountryList.forEach(item => {
          Object.assign(item, {
            cnName: countryMap.get(item.twoCode)?.name || '',
            countryId: countryMap.get(item.twoCode)?.countryId || '',
            enName: countryMap.get(item.twoCode)?.enName || ''
          });
        });
        i.countryTwoCodeList = zoneCountryList.map(item => item.twoCode);
        i.formula = processFreightText(i.priceType, false, true);
      });

      // 根据 coveredType 是否覆盖数据
      const handleData = (oldData) => coveredType === 2 ? data : mergeByCountriesStrict(oldData, data);
      // zoneName（默认区保留0，其余递增）
      const resetZoneName = (list = [], keepZero = false) => {
        let index = keepZero ? 1 : 0;
        return list.map(item => {
          if (keepZero && item.zoneName === '0') return item;
          return {...item, zoneName: String(index++)};
        });
      };

      switch (v.arriveableType) {
        // 1 全球可达运费相同
        case 1:
          let newData = data.flatMap(item => item.carrierShippingMethodSectionChargesList || []);
          v.data5.map((item) => {
            item.carrierShippingMethodSectionChargesList = newData;
            item.priceType = data[0]?.priceType;
            item.formula = data[0]?.formula;
            item.volumeWeight = data[0]?.volumeWeight;
            item.weightType = data[0]?.weightType;
          });
          v.data4 = [...v.data5];
          break;
        // 2 全球可达运费不同
        case 2:
          const base = v.data6.filter(i => i.zoneName === '0');
          const other = v.data6.filter(i => i.zoneName !== '0');
          let arr2 = coveredType === 2 ? [...base, ...data] : [...base, ...mergeByCountriesStrict(other, data)];
          const nonDefault = arr2.filter(i => i.zoneName !== '0');
          v.data6 = [...base, ...resetZoneName(nonDefault, true)];
          v.data4 = [...v.data6];
          break;
        // 3 非全球可达
        case 3:
          let arr3 = handleData(v.data7);
          v.data7 = resetZoneName(arr3, true);
          v.data4 = [...v.data7];
          break;
      }
      v.$refs['importFreightTemplate'].importFreightTemplateModal = false;
    },
    // 获取设置/编辑/新增自定义物流渠道弹窗的相关数据(查询物流方式设置详情)
    showShippingSetting(id, index) {
      let v = this;
      // 存下shippingMethodId和saleAccountId，详情保存时用到
      v.shippingMethodIdCopy = id;
      v.saleAccountIdCopy = v.$store.state.carrierAccountId;
      v.setShippingMethodStatus = true;
      v.getAllCountryName(true);
      (async () => {
        // 获取仓库列表
        getAllYmsWarehouseData().then((data) => {
          let carrierCodeList = ['temuHalfTl', 'tiktok'];
          if (carrierCodeList.includes(v.carrierCode)) {
            v.ymsWarehouseData = data;
          } else {
            v.ymsWarehouseData = data.filter((item) => !item.apiCode);
          }
        });
        await v.GetQuotingLogisticsData(true); // 获取从其他渠道引用的物流商数据
        v.warehouseIdList = [];
        v.goodsTagList = [];
        v.skuList = '';
        v.deliveryMethodForm.carrierShippingMethodAddressId = null;
        v.addressInfo.carrierAccountAddressList = [];
        if (id) {
          v.axios.get(api.get_carrierShippingMethod + id, {loading: true}).then(response => {
            if (response.data.code === 0) {
              v.logisticsChannelModal = true;
              let data = response.data.datas;
              v.modalData = data;
              let keyList = ['carrierShippingMethodName', 'remark'];
              let obj = v.handleMultilingualFormFields(data.carrierShippingMethod, keyList);
              let {carrierShippingMethodName, remark, logisticsCarrier, haulier, isCollectCancel, collectCancelType, ...obj1} = data.carrierShippingMethod;
              v.logisticsChannelModalParams.carrierShippingMethod = Object.assign({}, v.logisticsChannelModalParams.carrierShippingMethod, obj1, obj);
              v.logisticsChannelModalParams.carrierShippingMethod.carrierName = _handleMultilingualFields(data.carrier.carrierName);
              v.isOnline = data.carrier.isOnline;
              v.apiType = data.carrier.apiType; //  物流商类型 0:自营仓物流商   1:海外仓物流商
              v.apiInterface = data.carrier.apiInterface;
              if (data.baseDetail.acceptablePackageTypeList) {
                v.logisticsChannelModalParams.acceptablePackageTypeList = data.baseDetail.acceptablePackageTypeList.map(i => i.value);
              }
              let carrierShippingMethodPriceModel = data.carrierShippingMethodPriceModel;
              if (carrierShippingMethodPriceModel) {
                v.pricingParams.priceType = carrierShippingMethodPriceModel.priceType;
                v.freightDiscount = carrierShippingMethodPriceModel.freightDiscount;
                v.freightCurrency = carrierShippingMethodPriceModel.freightCurrency;
                v.freightDiscountType = carrierShippingMethodPriceModel.freightDiscountType;
                v.carrierShippingMethodPriceModelId = carrierShippingMethodPriceModel.carrierShippingMethodPriceModelId;
                if (carrierShippingMethodPriceModel.priceType === 3) {
                  v.setCachePriceModelColumns(data.carrierShippingMethodPriceModelZoneList);
                }
                v.pricingParams.weightType = carrierShippingMethodPriceModel.weightType;
                if (carrierShippingMethodPriceModel.priceType === 3) { // 如果是分段续费，则去分段那里取计费方式
                  v.pricingParams.subCostWay = data.carrierShippingMethodPriceModelZoneList[0].carrierShippingMethodSectionChargesList[0].priceType;
                }
              }
              // 适用仓库
              let carrierShippingMethodWarehouseList = data.carrierShippingMethodWarehouseList || [];
              v.warehouseIdList = carrierShippingMethodWarehouseList.map(item => item.warehouseId).filter(id => id);
              v.ymsWarehouseData.map((item) => {
                item.bindingText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005266');
                item.overseaShippingMethodId = null;
                carrierShippingMethodWarehouseList.map((ele) => {
                  if (item.ymsWarehouseId === ele.warehouseId) {
                    if (ele.overseaShippingMethodId) {
                      item.bindingText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005267');
                    }
                    item.overseaShippingMethodId = ele.overseaShippingMethodId;
                  }
                })
              })
              v.logisticsCarrierName = '';
              let logisticsCarrierLisat = [];
              if (logisticsCarrier && haulier) {
                logisticsCarrierLisat = [{nameCn: logisticsCarrier, name: haulier}];
                v.logisticsCarrierName = logisticsCarrier + ' > ' + haulier;
              }
              v.logisticsCarrier = logisticsCarrier;

              let newData = [...logisticsCarrierLisat, ...v.logisticsCarrierData];
              v.logisticsCarrierData = v.uniqueFunc(newData, 'code');
              v.carrierShippingMethodParmas = v.deepCopy(data.carrierShippingMethod);
              if (v.carrierShippingMethodParmas.arriveableType !== null && v.carrierShippingMethodParmas.arriveableType !== 0 && data.carrierShippingMethodPriceModelZoneList && data.carrierShippingMethodPriceModelZoneList.length > 0) {
                data.carrierShippingMethodPriceModelZoneList.forEach(i => {
                  if (i.carrierShippingMethodPriceModelZoneCountryList) {
                    i.countryTwoCodeList = i.carrierShippingMethodPriceModelZoneCountryList.map(j => {
                      return j.twoCode;
                    });
                  }
                });
                v.$nextTick(() => {
                  let zoneList = data.carrierShippingMethodPriceModelZoneList;
                  v.arriveableType = v.carrierShippingMethodParmas.arriveableType;
                  v.data4 = zoneList;
                  if (v.arriveableType === 1) {
                    v.data5 = zoneList;
                  } else if (v.arriveableType === 2) {
                    v.data6 = zoneList; // 计费模型
                  } else if (v.arriveableType === 3) {
                    v.data7 = zoneList; // 计费模型
                  }
                });
              } else {
                v.arriveableType = 1;
                v.data4 = v.data5; // data5 为默认值
              }
              v.cachePricingData = data.carrierShippingMethodPriceModelZoneList;
              // 获取各平台物流服务商
              v.makePlatformGroup().then(() => {
                v.makeCarrierCode().then(result => {
                  if (result) {
                    let cm = data.carrierShippingMethod;
                    v.systemShippingMethodId = cm.systemShippingMethodId;
                    v.shippingMethodId = cm.shippingMethodId;
                    let cp = data.carrierParams;
                    let pcs = data.platformCarrierSettings;
                    let cpArr = [];
                    cp.forEach((n, i) => { // 整理初始化保存数据
                      if (n.paramValue === null) {
                        n.paramValue = '';
                      }
                      cpArr.push({
                        paramKey: n.paramKey,
                        paramValue: n.paramValue,
                        dataType: n.dataType
                      });
                    });
                    if (pcs.length > 0) {
                      var obj = v.deepCopy(v.shippingParams.platformCarrierSettings);
                      let platObj = {};// 判断选中平台
                      pcs.forEach((n, i) => {
                        // 将自定义的物流商服务数据添加到基础数据中
                        let list = v.carrierCodeArr[n.platformId] || [];
                        if (list.length > 0) {
                          let talg = list.every((item) => {
                            return item.valueCode !== n.carrierCode;
                          });
                          if (talg) {
                            list.push({
                              valueCnName: n.carrierCode,
                              valueCode: n.carrierCode,
                            });
                          }
                          v.carrierCodeArr[n.platformId] = v.uniqueFunc(list, 'valueCode');
                        }
                        if (!platObj.hasOwnProperty(n.platformId)) {
                          v.platformGroup.forEach((g, k) => {
                            if (g.platformId === n.platformId) {
                              v.platformGroup[k].checkboxStatus = true;
                            }
                          });
                          platObj[n.platformId] = 1;
                        }
                        if (n.platformId === null) {
                          n.platformId = 'ebay';
                        }
                        if (n.platformId === "amazon" && n.carrierCode) {
                          let list = [
                            {
                              valueCode: n.shippingService,
                              valueCnName: n.shippingService,
                            },
                          ];
                          v.getDeliveryList(n.platformId, n.platformId + "_" + n.carrierCode, n.shippingService, list);
                        }
                        if ((n.countryCode === null || n.countryCode === '') && obj.hasOwnProperty(n.platformId)) {
                          obj[n.platformId][0] = Object.assign(obj[n.platformId][0], n);
                        } else if (n.countryCode !== null && n.countryCode !== '' && obj.hasOwnProperty(n.platformId)) {
                          obj[n.platformId].push({ // 整理参数
                            carrierCode: n.carrierCode,
                            countryCode: n.countryCode,
                            platformId: n.platformId === null ? 'ebay' : n.platformId,
                            trackingNumberType: n.trackingNumberType,
                            pickUpType: n.pickUpType,
                            markDeliveryType: n.markDeliveryType,
                            deliveryCountryCode: n.deliveryCountryCode,
                            shippingService: n.shippingService,
                          });
                        }
                        _setAllowCreateValue(n);
                      });

                      // 设置自定义属性值
                      function _setAllowCreateValue(n) {
                        if (v.carrierCodeArr[n.platformId].every((k) => k.valueCode !== n.carrierCode)) {
                          v.carrierCodeArr[n.platformId].push({
                            valueCode: n.carrierCode,
                            valueCnName: n.carrierCode,
                          });
                        }
                      }

                      v.$set(v.shippingParams, 'platformCarrierSettings', obj);
                    }
                    v.shippingParams.carrierParams = cpArr;
                    if (cm.isPrintPickingList === 1) {
                      v.shippingParams.isPrintPickingList = 1;
                    }
                    v.shippingParams.shippingMethodId = cm.shippingMethodId;
                    v.shippingData = data;
                    v.showMarkShipping = true;
                    v.$nextTick(function () {
                      v.shippingMethodSpinLoading = false;
                    });
                  }
                });
              });
              // 线上物流渠道才有渠道地址信息
              let carrierShippingMethodAddress = data.carrierShippingMethodAddress || [];
              if (v.isOnline === 1) {
                if (carrierShippingMethodAddress.length > 0) {
                  carrierShippingMethodAddress.map((item) => {
                    item.edisShippingType = Number(item.edisShippingType);
                    v.countrysData.map((country) => {
                      if (item.countryCode === country.twoCode) {
                        item.countryId = country.countryId;
                      }
                    });
                  });
                  v.handlerAddressData(carrierShippingMethodAddress);
                } else {
                  v.handleDefaultAddressData();
                }
              }
              // 交货方式的地址
              if (data.carrierShippingMethod) {
                v.deliveryMethodForm.deliveryType = Number(data.carrierShippingMethod.deliveryType) || 2;
                v.deliveryMethodForm.domesticExpressFee = Number(data.carrierShippingMethod.domesticExpressFee) || null;
                v.deliveryMethodForm.deliveryAddressType = Number(data.carrierShippingMethod.deliveryAddressType) || 1;
              }
              let deliveryAddressList = carrierShippingMethodAddress.filter((item) => {
                return item.addressType === 'delivery';
              });
              if (deliveryAddressList.length > 0) {
                let obj = deliveryAddressList[0];
                v.deliveryMethodForm.carrierShippingMethodAddressId = obj.carrierShippingMethodAddressId;
                if (obj.ymsAddressTemplateId) {
                  v.deliveryMethodForm.ymsAddressTemplateId = obj.ymsAddressTemplateId;
                  if (v.addressTemplateData.length > 0) {
                    let newList = v.addressTemplateData.filter((ele) => {
                      return ele.ymsAddressTemplateId === obj.ymsAddressTemplateId;
                    });
                    if (newList && newList.length > 0) {
                      v.deliveryMethodForm.addressDetails = newList[0];
                      if (v.countrysData.length > 0) {
                        v.countrysData.map((talg) => {
                          if (talg.twoCode === newList[0].countryCode) {
                            v.deliveryMethodForm.addressDetails.countryCode = talg.cnName;
                          }
                        });
                      }
                    }
                  }
                }
                v.$forceUpdate();
              }
              // 物流费配置
              v.isCollectCancel = isCollectCancel || 0;
              v.collectCancelType = collectCancelType || 2;
              let carrierShippingMethodCanceledPrices = data.carrierShippingMethodCanceledPrices || [];
              if (carrierShippingMethodCanceledPrices.length > 0) {
                v.feeCollectionConfigList = [];
                v.currencySystem = carrierShippingMethodCanceledPrices[0].priceCurrency;
                carrierShippingMethodCanceledPrices.map((item, index) => {
                  v.feeCollectionConfigList.push({
                    minHour: item.startTime,
                    maxHour: carrierShippingMethodCanceledPrices.length - 1 === index ? null : item.endTime,
                    invalidFees: collectCancelType === 2 ? isValueEmpty(item.price) ? null : item.price : null,
                    logisticsFee: collectCancelType === 1 ? isValueEmpty(item.price) ? null : Number(toPercent(item.price, 2, false)) : null,
                    currency: item.priceCurrency,
                    startErrorText: '',
                    endErrorText: '',
                    priceText: '',
                    errorText: '',
                    disabled: index !== 0,
                  });
                });
              }
            }
          });
        }
      })();
    },
    // 处理发货设置地址的默认数据
    handleDefaultAddressData() {
      let v = this;
      // 默认展示寄件、退件人地址模板
      let addressTypeList = ['sender', 'return'];
      // 物流渠道为eDIS物流，才有揽收地址信息
      if (v.apiInterface === 'API_EDIS') {
        addressTypeList.push('pickup');
      }
      v.addressList.map((item) => {
        if (addressTypeList.includes(item.addressType)) {
          v.addressInfo.carrierAccountAddressList.push(item);
        }
      });
      // 处理按照 寄件、揽收、退货顺序排序
      let order = ['sender', 'pickup', 'return'];
      v.addressInfo.carrierAccountAddressList.sort((a, b) => order.indexOf(a.addressType) - order.indexOf(b.addressType));
    },

    // 设置表格列
    setTableColumns(type) {
      let v = this;
      if (type === 1) {
        v.pricingModelColumns = v.pricingModelCommonColumns;
      } else if (type === 2) {
        v.getNewArr(v.pricingModelCommonColumns).then(arr => {
          arr.splice(2, 1, ...v.pricingModelContinuedHeavyColumns);
          v.pricingModelColumns = arr;
        });
      } else {
        v.getNewArr(v.pricingModelCommonColumns).then(arr => {
          arr.splice(2, 1, ...v.cachePriceModelColumns);
          v.pricingModelColumns = arr;
        });
      }
    },

    // 浅拷贝数组
    getNewArr(arr) {
      let newArr = [];
      return new Promise(resolve => {
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i];
          newArr.push(item);
          if (i === arr.length - 1) {
            resolve(newArr);
          }
        }
      });
    },

    // 获取物流服务商
    makeCarrierCode() {
      let v = this;
      return new Promise(resolve => {
        v.carrierCodeArr = Object.create(null);
        v.shippingParams.platformCarrierSettings = Object.create(null);
        if (v.platformGroup !== null && v.platformGroup.length > 0) {
          let arr = [];
          for (let k = 0; k < v.platformGroup.length; k++) {
            let platformItem = v.platformGroup[k];
            platformItem.checkboxStatus = false;
            v.carrierCodeArr[platformItem.platformId] = [];
            let obj = {
              parameterCode: platformItem.platformId,
              parameterName: 'carrierCode'
            };
            v.axios.post(api.get_orderCommonParameter, JSON.stringify(obj)).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas || [];
                v.$set(v.carrierCodeArr, platformItem.platformId, data);
                let platObj = {
                  carrierCode: '',
                  trackingNumberType: 0,
                  platformId: platformItem.platformId,
                  markDeliveryType: 0
                };
                v.$set(v.shippingParams.platformCarrierSettings, platformItem.platformId, [platObj]);
                arr.push(1);
                if (arr.length === v.platformGroup.length) { // 这里出问题
                  resolve(true);
                }
              }
            });
          }
        } else {
          resolve(true);
        }
      });
    },

    // 获取设置/编辑/新增自定义物流渠道弹窗的表单参数
    handleSubmit(name) {
      let v = this;
      let result = true;
      v.$refs[name].validate(function (valid) {
        result = !!valid;
      });
      return result;
    },

    // 重置弹窗数据
    resetShippingData() {
      let v = this;
      v.shippingLoading = false;
      v.$nextTick(function () {
        v.shippingLoading = true;
      });
      v.openType = 'look';
      v.logisticsChannelModal = false;
    },

    // 重置弹窗表单数据
    resetData() {
      let v = this;
      v.buttonTalg = false;
      v.arriveableType = 1;
      v.checkboxLimit = '0';
      v.carrierCodeArr = null;
      v.shippingParams = {
        shippingMethodId: '',
        shippingData: null,
        carrierParams: [],
        platformCarrierSettings: null,
        isPrintPickingList: 0
      };
      v.shippingMethodSpinLoading = true;
      v.showMarkShipping = false;
      // 基础信息
      v.logisticsChannelModalParams = {
        acceptableCityList: null,
        acceptablePackageTypeList: [],
        carrierShippingMethod: {
          carrierShippingMethodCode: '',
          logisticsInterface: '',
          shipCompanyId: '',
          minEfficiency: 0,
          maxEfficiency: 0,
          isInsurance: 0,
          maxLength: 0,
          maxWidth: 0,
          maxHeight: 0,
          minWeight: 0,
          maxWeight: 0,
          maxPerimeter: 0,
          maxDimensionsLength: 0,
          minVolume: 0,
          maxVolume: 0,
          acceptablePackageTypeList: null,
          hasTrackingNumber: null,
          logisType: 1,
          isSupportInterfaceTransferBill: 0,
          isRequiredConfirm: 0,
          arriveableType: '1',
          performanceType: 1
        }
      };
      v.logisticsCarrier = null;
      v.logisticsCarrierName = '';
      if (v.isOnline === 1) {
        v.$refs['addressInfo'].resetFields();
      }
    },

    // 获取所有平台的数据
    makePlatformGroup() {
      let v = this;
      let platformGroup = v.$store.state.platformGroup || JSON.parse(localStorage.getItem('platformGroup'));
      return new Promise(resolve => {
        if (!platformGroup) {
          getEnabledPlatforms().then(result => {
            if (result) {
              v.platformGroup = result;
              resolve(v.platformGroup);
            }
          });
        } else {
          v.platformGroup = platformGroup;
          resolve(v.platformGroup);
        }
      });
    },

    // 设置店铺的数据
    setShopGroup(shopList, openList) { // 加载适用平台帐号列表
      let v = this;
      let obj = {};
      let arrObj = {
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'),
        expand: true,
        children: []
      };
      let platformGroup = v.$store.state.platformGroup;
      if (platformGroup && platformGroup.length > 0) {
        function makePlatformGroup() { // 读可用平台列表
          return new Promise(resolve => {
            for (let i = 0; i < platformGroup.length; i++) {
              if (!obj.hasOwnProperty(platformGroup[i].platformId)) {
                arrObj.children.push({
                  title: platformGroup[i].platformId,
                  saleAccountId: null,
                  expand: true,
                  children: []
                });
                obj[platformGroup[i].platformId] = arrObj.children.length - 1;
              }
              if (i === platformGroup.length - 1) {
                resolve(true);
              }
            }
          });
        }

        function makeRangeShopList() { // 适用平台帐号
          return new Promise(resolve => {
            for (let t = 0; t < shopList.length; t++) {
              let item = shopList[t];
              arrObj.children[obj[item.platformId]].children = [];
              if (obj.hasOwnProperty(item.platformId) && openList && openList.length > 0) {
                for (let i = 0; i < openList.length; i++) {
                  let sItem = openList[i];
                  let subItem = {
                    title: item.account,
                    saleAccountId: item.saleAccountId,
                    checked: (sItem.saleAccountId === item.saleAccountId && sItem.platformId === item.platformId) || (sItem.saleAccountId === null && sItem.platformId === item.platformId) || false,
                    platformId: item.platformId,
                    expand: false,
                    children: []
                  };
                  if (sItem.saleAccountId === null) {
                    arrObj.children.forEach((p, g) => {
                      if (p.title === sItem.platformId) {
                        p.checked = true;
                      }
                    });
                  }
                  if (sItem.platformId === item.platformId) {
                    arrObj.children[obj[item.platformId]].children.push(subItem);
                  }

                  if (t === shopList.length - 1) resolve(true);
                }
              } else if (obj.hasOwnProperty(item.platformId) && openList && openList.length === 0) {
                let subItem = {
                  title: item.account,
                  saleAccountId: item.saleAccountId,
                  checked: false,
                  platformId: item.platformId,
                  expand: false,
                  children: []
                };
                arrObj.children[obj[item.platformId]].children.push(subItem);
                if (t === shopList.length - 1) resolve(true);
              } else {
                resolve(true);
              }
            }
          });
        }

        function setShopAccount() {
          v.shopAccount = [arrObj];
        }

        async function getStartMakeShop() {
          const result = await makePlatformGroup();
          if (result) {
            const mslResult = await makeRangeShopList();
            if (mslResult) {
              await setShopAccount();
            }
          }
        }

        getStartMakeShop();
      }
    },

    // 设置计费模型编辑弹窗的表格
    setCachePriceModelColumns(cData) {
      let v = this;
      v.cachePriceModelColumns = [];
      for (let i = 0; i < cData[0].carrierShippingMethodSectionChargesList.length; i++) {
        let item = cData[0].carrierShippingMethodSectionChargesList[i];
        let culumnItem = {
          align: 'center',
          minWidth: 230,
          renderHeader: (h, col) => {
            return h('div', [
              h('span', item.startWeight),
              h('span', {
                style: {
                  margin: '0 3px'
                }
              }, '-'),
              h('span', item.endWeight),
              h('span', {
                style: {
                  margin: '0 3px'
                }
              }, 'g')
            ]);
          },
          render: (h, params) => {
            if (item.priceType === 3) { // 编辑状态下，priceType等于3时返回结果
              return h('div', {
                style: {
                  padding: '8px 0'
                }
              }, [
                h('div', {
                  class: 'flex'
                }, [
                  h('span', {
                    style: {
                      color: 'red',
                      marginRight: '5px',
                      position: 'relative',
                      top: '8px'
                    }
                  }, '*'),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-right': '5px'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005268')),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-right': '5px'
                    }
                  }, v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].firstWeight),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin': '0 5px'
                    }
                  }, 'g'),
                  h('InputNumber', {
                    props: {
                      value: v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].firstWeightPrice,
                      min: 0,
                      max: 9999999,
                      size: 'small'
                    },
                    style: {
                      width: '60px',
                      marginTop: '3px'
                    },
                    on: {
                      'input': (val) => {
                        v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].firstWeightPrice = val;
                      }
                    }
                  }),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-left': '5px'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005269'))
                ]), h('div', {
                  class: 'flex mt20 flexBoxJustContent'
                }, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                    class: 'redColor'
                  }, Math.round((v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].firstWeightPrice * (v.freightDiscount === null
                    ? 100
                    : v.freightDiscount) / 100) * 100) / 100)
                ]), h('div', {
                  class: 'flex mt20'
                }, [
                  h('span', {
                    style: {
                      color: 'red',
                      marginRight: '5px',
                      position: 'relative',
                      top: '8px'
                    }
                  }, '*'),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-right': '5px'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005270')),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-right': '5px'
                    }
                  }, v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].unitWeight),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin': '0 5px'
                    }
                  }, 'g'),
                  h('InputNumber', {
                    props: {
                      value: v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].unitWeightPrice,
                      min: 0,
                      max: 9999999,
                      size: 'small'
                    },
                    style: {
                      width: '60px',
                      marginTop: '3px'
                    },
                    on: {
                      'input': (val) => {
                        v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].unitWeightPrice = val;
                      }
                    }
                  }),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-left': '5px'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005269'))
                ]), h('div', {
                  class: 'flex mt20 flexBoxJustContent'
                }, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                    class: 'redColor'
                  }, Math.round((v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].unitWeightPrice * (v.freightDiscount === null
                    ? 100
                    : v.freightDiscount) / 100) * 100) / 100)
                ])
              ]);
            } else if (item.priceType === 2) { // 编辑状态下，priceType等于2时返回结果
              return h('div', [
                h('span', {
                  style: {
                    color: 'red',
                    marginRight: '5px',
                    position: 'relative',
                    top: '5px'
                  }
                }, '*'),
                h('InputNumber', {
                  props: {
                    value: v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price,
                    max: 9999999,
                    min: 0
                  },
                  style: {
                    width: '80%'
                  },
                  on: {
                    'input': (val) => {
                      v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price = val;
                    }
                  }
                }),
                h('div', {
                  class: 'flex mt20 flexBoxJustContent'
                }, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'),
                  h('span', {
                    class: 'redColor'
                  }, Math.round((v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price * (v.freightDiscount === null
                    ? 100
                    : v.freightDiscount) / 100) * 100) / 100)
                ])
              ]);
            } else if (item.priceType === 1) { // 编辑状态下，priceType等于1时返回结果
              return h('div', {
                class: 'flex'
              }, [
                h('span', {
                  style: {
                    color: 'red',
                    marginRight: '5px',
                    position: 'relative',
                    top: '10px'
                  }
                }, '*'),
                h('InputNumber', {
                  props: {
                    value: v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price,
                    max: 9999999,
                    min: 0
                  },
                  style: {
                    width: '75%'
                  },
                  on: {
                    'input': (val) => {
                      v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price = val;
                    }
                  }
                }),
                h('span', {
                  style: {
                    position: 'relative',
                    top: '6px',
                    'margin-left': '5px'
                  }
                }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005269') + '/g'), h('div', {
                  class: 'flex mt20 flexBoxJustContent'
                }, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'),
                  h('span', {
                    class: 'redColor'
                  }, Math.round((v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price * (v.freightDiscount === null
                    ? 100
                    : v.freightDiscount) / 100) * 100) / 100)
                ])
              ]);
            }
          }
        };
        v.cachePriceModelColumns.push(culumnItem);
      }
    },
    // 获取从其他渠道引用的物流商数据
    GetQuotingLogisticsData(loading) {
      this.$refs.channelReference.selectProviderList = [];
      this.axios.get(api.get_carrier_queryForEnableCarriers, {loading: loading}).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.datas || [];
          if (data.length > 0) {
            data.map((item) => {
              this.$refs.channelReference.selectProviderList.push({
                id: item.carrierId,
                name: item.carrierName
              });
            });
          }
        }
      });
    },
    // 引用其他物流渠道
    saveChannel(data) {
      if (data) {
        this.arriveableType = data.arriveableType;
        let list = data.list;
        if (list && list.length > 0) {
          list.forEach(i => {
            i.carrierShippingMethodPriceModelId = this.carrierShippingMethodPriceModelId;
            if (i.carrierShippingMethodPriceModelZoneCountryList) {
              i.countryTwoCodeList = i.carrierShippingMethodPriceModelZoneCountryList.map(j => {
                return j.twoCode;
              });
            }
          });
          this.data4 = [];
          if (this.arriveableType === 1) {
            this.data5 = list;
            this.data4 = JSON.parse(JSON.stringify(this.data5));
          } else if (this.arriveableType === 2) {
            this.data6 = list;
            this.data4 = JSON.parse(JSON.stringify(this.data6));
          } else if (this.arriveableType === 3) {
            this.data7 = list;
            this.data4 = JSON.parse(JSON.stringify(this.data7));
          }
        }
      }
    },
    blurChange() {
      let obj = this.logisticsChannelModalParams.carrierShippingMethod;
      let keyList = [
        'minVolume',
        'maxVolume',
        'maxDimensionsLength',
        'maxPerimeter',
        'maxWeight',
        'minWeight',
        'maxLength',
        'maxWidth',
        'maxHeight',
        'minEfficiency',
        'maxEfficiency'
      ];
      for (let key in obj) {
        if (keyList.includes(key)) {
          if (obj[key] === null) {
            obj[key] = 0;
          }
        }
      }
    },
    // 整合通达国家数据
    getPricingReachStateData(reachStateArr) {
      let arr = [];
      if (reachStateArr) { // reachStateArr 不为null
        for (let i = 0; i < reachStateArr.length; i++) {
          let item = reachStateArr[i];
          arr.push(item.cnName);
          if (i === reachStateArr.length - 1) {
            return arr.toString();
          }
        }
      }
    },
    //处理地址模板的相关数据
    handlerAddressData(carrierShippingMethodAddress) {
      let v = this;
      carrierShippingMethodAddress.map((item) => {
        item.addressDetails = {};
        if (item.ymsAddressTemplateId) {
          if (v.addressTemplateData.length > 0) {
            let newList = v.addressTemplateData.filter((ele) => {
              return ele.ymsAddressTemplateId === item.ymsAddressTemplateId;
            });
            if (newList && newList.length > 0) {
              item.addressDetails = newList[0];
              if (v.countrysData.length > 0) {
                v.countrysData.map((talg) => {
                  if (talg.twoCode === newList[0].countryCode) {
                    item.addressDetails.countryCode = talg.cnName;
                  }
                });
              }
            }
          }
        }
      });
      v.addressInfo.carrierAccountAddressList = carrierShippingMethodAddress;
      // 处理按照 寄件、揽收、退货顺序排序
      let order = ['sender', 'pickup', 'return'];
      v.addressInfo.carrierAccountAddressList.sort((a, b) => order.indexOf(a.addressType) - order.indexOf(b.addressType));
      v.$forceUpdate();
    },
    // 切换交货方式
    deliveryMethodChange(value) {
      this.deliveryMethodForm.domesticExpressFee = null;
      this.deliveryMethodForm.ymsAddressTemplateId = null;
    },
    // 新增地址模板
    addAddressTemplateBtn() {
      const {href} = this.$router.resolve({
        path: '/addressLibraryManage',
        query: {
          addressLibraryType: 'add'
        }
      });
      window.open(href, '_blank');
    },
    // 更新地址模板数据
    openChange(value) {
      if (value) {
        this.getAddressTemplateData();
      }
    },
    // 选择地址模板
    selectChange(ymsAddressTemplateId, addressType) {
      if (this.addressTemplateData.length > 0) {
        let newList = this.addressTemplateData.filter((item) => {
          return item.ymsAddressTemplateId === ymsAddressTemplateId;
        });
        if (newList && newList.length > 0) {
          if (addressType) {
            this.addressInfo.carrierAccountAddressList.map((ele) => {
              if (ele.addressType === addressType) {
                ele.addressDetails = newList[0];
                if (this.countrysData.length > 0) {
                  this.countrysData.map((talg) => {
                    if (talg.twoCode === newList[0].countryCode) {
                      ele.addressDetails.countryCode = talg.cnName;
                    }
                  });
                }
              }
            });
          } else {
            this.deliveryMethodForm.addressDetails = newList[0];
            if (this.countrysData.length > 0) {
              this.countrysData.map((talg) => {
                if (talg.twoCode === newList[0].countryCode) {
                  this.deliveryMethodForm.addressDetails.countryCode = talg.cnName;
                }
              });
            }
          }
          this.$forceUpdate();
        }
      }
    },
    // 自定义物流商服务
    customizedLogisticsServiceProvider(value, platformId, type, scIndex) {
      let newList = [];
      let newData = this.carrierCodeArr[platformId];
      if (newData.length > 0) {
        newList = JSON.parse(JSON.stringify(newData));
      }
      if (value) {
        let exists = newList.some((item) => {
          return item.valueCode === value || item.valueCnName === value;
        });
        if (!exists) {
          newList.push({
            valueCode: value,
            valueCnName: value
          });
          this.carrierCodeArr[platformId] = newList;
          if (type === 'specialCase') {
            this.shippingParams.platformCarrierSettings[platformId][scIndex].carrierCode = value;
          } else {
            this.shippingParams.platformCarrierSettings[platformId][0].carrierCode = value;
          }
        } else {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005271'));
          return false;
        }
      }
    },
    // 自定义配送服务
    handleCreateDelivery(value) {
      let newList = [];
      if (this.amazonDeliveryList.length > 0) {
        newList = JSON.parse(JSON.stringify(this.amazonDeliveryList));
      }
      if (value) {
        let exists = newList.some((item) => {
          return item.valueCode === value;
        });
        if (!exists) {
          newList.push({
            valueCode: value,
            valueCnName: value,
          });
          this.amazonDeliveryList = newList;
        } else {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005238'));
          return false;
        }
      }
    },
    async getDeliveryList(platformId, parameterCode, shippingService, list) {
      const {data} = await this.axios.post(api.get_orderCommonParameter, {
        parameterCode: parameterCode,
        parameterName: "shippingService",
      });
      this[platformId + "DeliveryList"] = [];
      let {code, datas} = data;
      if (code === 0) {
        if (shippingService) {
          let talg = datas.some((item) => {
            return item.valueCode === shippingService;
          });
          if (!talg) {
            this[platformId + "DeliveryList"] = [...datas, ...list];
          }
        } else {
          this[platformId + "DeliveryList"] = datas;
        }
      }
    },
    // 获取承运方数据
    getLogisticsCarrierData(type) {
      let v = this;
      return new Promise((resolve) => {
        v.isScroll = false;
        v.axios.post(api.post_systemTrackingMoreCarrier_query, v.pages).then((res) => {
          if (res.data.code === 0) {
            v.selectLoading = false;
            let data = res.data.datas;
            let list = data.list || [];
            let newList = [];
            if (type === 'search') {
              if (list.length > 0) {
                let newData = [...list, ...v.originalData];
                v.logisticsCarrierData = v.uniqueFunc(newData, 'code');
              } else {
                v.logisticsCarrierData = JSON.parse(JSON.stringify(v.originalData));
              }
              v.showMore = true;
              v.isScroll = true;
              v.pages.pageNum = 1;
            } else {
              newList = [...v.logisticsCarrierData, ...list];
              v.logisticsCarrierData = v.uniqueFunc(newList, 'code');
              v.originalData = JSON.parse(JSON.stringify(newList));
              if (v.logisticsCarrierData.length >= data.total) {
                v.showMore = false;
                v.isScroll = false;
              } else {
                v.showMore = true;
                v.isScroll = true;
              }
            }
            resolve(true);
          } else {
            v.selectLoading = false;
          }
        });
      });
    },
    selectQueryChange(query) {
      this.enterSearch(query);
    },
    // 搜索承运方
    enterSearch(value) {
      let v = this;
      if (value) {
        let val = value.replace(/^\s*|\s*$/g, '');
        v.pages.nameCn = val;
        v.pages.pageNum = 1;
        v.searchTimer = setTimeout(() => {
          v.selectLoading = true;
          v.getLogisticsCarrierData('search').then(() => {
            v.pages.nameCn = '';
            v.pages.pageNum = 1;
          });
        }, 500);
      } else {
        v.logisticsCarrierData = JSON.parse(JSON.stringify(v.originalData));
      }
    },
    // 滚动加载更多数据
    selectMore() {
      let v = this;
      if (v.showMore && v.isScroll) {
        v.pages.pageNum += 1;
        v.getLogisticsCarrierData();
      }
    },
    // 选择计费币种
    currencySystemChange(value) {
      this.feeCollectionConfigList.map((item) => {
        item.currency = value;
      });
      this.$forceUpdate();
    },
    // 选择费用收取方式
    feeCollectionMethodTypeChange(value) {
      this.feeCollectionConfigList.map((item) => {
        if (value === 2) {
          item.invalidFees = null;
        }
        if (value === 1) {
          item.logisticsFee = null;
        }
        item.errorText = '';
        item.startErrorText = '';
        item.endErrorText = '';
        item.priceText = '';
      });
      this.$forceUpdate();
    },
    // 删除物流单作废费配置
    deleteFeeCollectionConfigBtn(idx) {
      this.feeCollectionConfigList.splice(idx, 1);
      if (this.feeCollectionConfigList.length <= 1) {
        this.feeCollectionConfigList.map((item) => {
          item.disabled = false;
        });
      } else {
        this.feeCollectionConfigList.map((item, index) => {
          if (index === 0) {
            item.disabled = false;
          }
        });
      }
      this.$forceUpdate();
    },
    // 添加物流单作废费配置
    addAFeeCollectionConfigBtn() {
      const prev = this.feeCollectionConfigList[this.feeCollectionConfigList.length - 1];
      this.feeCollectionConfigList.push({
        minHour: prev && prev.maxHour != null ? prev.maxHour : null,
        maxHour: null,
        invalidFees: null,
        logisticsFee: null,
        currency: this.currencySystem,
        startErrorText: '',
        endErrorText: '',
        priceText: '',
        errorText: '',
        disabled: true,
      });
    },
    // 自动处理区间值的数据
    blurEndInput(item, index) {
      let v = this;
      let lastIndex = v.feeCollectionConfigList.length - 1;
      if (index < lastIndex) {
        let value = item.maxHour;
        if (value) {
          v.$set(v.feeCollectionConfigList[index + 1], 'minHour', value);
          v.$forceUpdate();
        }
      }
      v.verificationInterval(item, index, 'right');
    },
    // 校验左右区间大小的问题
    verificationInterval(item, index, type) {
      let v = this;
      let startVal = item.minHour;
      let endVal = item.maxHour;
      let cost = v.collectCancelType === 2 ? item.invalidFees : item.logisticsFee;
      if (type === 'left') {
        if (isValueEmpty(startVal)) {
          v.$set(v.feeCollectionConfigList[index], 'errorText', '');
          v.$set(v.feeCollectionConfigList[index], 'startErrorText', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002428'));
        } else {
          v.$set(v.feeCollectionConfigList[index], 'startErrorText', '');
        }
      }
      if (type === 'right') {
        if (isValueEmpty(endVal)) {
          if (index !== this.feeCollectionConfigList.length - 1) {
            v.$set(v.feeCollectionConfigList[index], 'errorText', '');
            v.$set(this.feeCollectionConfigList[index], 'endErrorText', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002429'));
          }
        } else {
          v.$set(this.feeCollectionConfigList[index], 'endErrorText', '');
        }
      }
      if (type === 'price') {
        let text = v.collectCancelType === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005272') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005273');
        if (isValueEmpty(cost)) {
          v.$set(this.feeCollectionConfigList[index], 'priceText', text);
        } else {
          v.$set(this.feeCollectionConfigList[index], 'priceText', '');
        }
      }
      if (!isValueEmpty(startVal) && !isValueEmpty(endVal)) {
        if (startVal >= endVal || endVal <= startVal) {
          v.$set(v.feeCollectionConfigList[index], 'errorText', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002431'));
        } else {
          v.$set(v.feeCollectionConfigList[index], 'errorText', '');
        }
      }
      v.$forceUpdate();
    },
    // 3PL物流绑定标识
    showLogisticsBinding(item) {
      let ymsWarehouseId = item.ymsWarehouseId;
      let apiCode = item.apiCode;
      let carrierCodeList = THIRD_PARTY_WAREHOUSE.map((item) => item.carrierCode);
      return this.warehouseIdList.includes(ymsWarehouseId) && carrierCodeList.includes(apiCode);
    },
    // 3PL物流绑定
    logisticsBindingBtn(item) {
      let obj = {
        apiWarehouseId: item.apiWarehouseId,
        ymsWarehouseId: item.ymsWarehouseId,
        overseaShippingMethodId: item.overseaShippingMethodId,
        carrierCode: this.carrierCode
      };
      this.$refs['logisticsBinding'].initLogisticsBindingData('single', obj);
    },
    // 更新绑定物流信息
    updateLogisticsBinding() {
      this.initLogisticsChannelData(this.openType, this.shippingMethodIdCopy);
    },
    // 更新当前仓库绑定3PL物流信息
    updateBindingInfo(list) {
      this.ymsWarehouseData.map((item) => {
        list.map((ele) => {
          if (item.ymsWarehouseId === ele.warehouseId) {
            if (ele.overseaShippingMethodId) {
              item.overseaShippingMethodId = ele.overseaShippingMethodId;
              item.bindingText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005267');
            } else {
              item.overseaShippingMethodId = null;
              item.bindingText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005266');
            }
          }
        });
      });
      this.$forceUpdate();
    },
    // 关闭之前的二次弹窗提示确认
    handleBeforeClose() {
      let v = this;
      return new Promise((resolve, reject) => {
        if (v.openType !== 'look' && v.verificationTalg) {
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000701'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000702'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
            onOk: () => {
              v.resetAllData();
              resolve();
            },
            onCancel: () => {
              reject();
            }
          });
        } else {
          resolve();
        }
      });
    },
    // 取消按钮
    cancelBtn() {
      this.handleBeforeClose().then(() => {
        this.logisticsChannelModal = false;
      });
    },
    // 获取履约方式名称
    getPerformanceMethodName(value) {
      const item = this.performanceMethodlist.find(item => item.value === value);
      return item ? item.name : '';
    }
  },
  watch: {
    arriveableType: {
      handler(newVal) {
        this.data4 = [];
        if (newVal === 1) {
          this.data4 = JSON.parse(JSON.stringify(this.data5));
        } else if (newVal === 2) {
          this.data4 = JSON.parse(JSON.stringify(this.data6));
        } else if (newVal === 3) {
          this.data4 = JSON.parse(JSON.stringify(this.data7));
        }
      },
      deep: true,
      immediate: true
    },
    'pricingParams.priceType': {
      handler(n, o) {
        if (n !== o) {
          this.setTableColumns(n);
        }
      }
    },
    // 适用仓库
    warehouseIdList: {
      handler(data) {
        if (data.length > 0) {
          this.checkAll = data.length === this.ymsWarehouseData.length;
        }
      },
      deep: true,
      immediate: true
    },
  },
  beforeDestroy() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  },
  components: {
    languagesTabs,
    importFreightTemplateModal,
    channelReferenceModal,
    billingModelEditingModal,
    logisticsBindingModal
  }
};
</script>
<style lang="less">
.logistic .logisticStyles {
  font-size: 14px;

  .redColor {
    color: red;
  }

  .logi-CheckboxGroup .ivu-checkbox-wrapper {
    display: inline !important;
  }

  .ivu-modal-body {
    max-height: 700px;
    overflow-y: auto;

    .redDot:before {
      content: '*';
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-family: SimSun;
      font-size: 12px;
      color: #ed4014;
    }

    .set_card_style {
      .ivu-card-head {
        border-bottom: 1px solid #e8eaec;
        padding: 11px 15px;
        line-height: 1;
        background-color: #f7f7f7;

        .title_box {
          color: #333;
          font-size: 17px;
          font-weight: bold;
        }
      }
    }

    .addressBoxStyle {
      display: flex;

      .addressStyle_item {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin: 0 10px;
        box-sizing: border-box;

        .ivu-card-head {
          padding: 8px 2px;
          background-color: transparent;
        }

        .ivu-card-body {
          padding: 12px 0;
        }

        .title_center {
          font-size: 15px;
          color: #333;
          font-weight: bold;
        }
      }
    }

    .basic_item {
      line-height: inherit;
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      .basic_title {
        min-width: initial;
        display: inline-block;
      }

      .basic_txt {
        display: inline-block;
        max-width: 260px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .fontBold, .fontWeight {
      font-weight: 700;
    }

    .platformTitle {
      border-right: 1px solid #eee;
      font-weight: 700;
      justify-content: left;
      align-items: center;
      width: 120px;
      flex-shrink: 0;
      padding-left: 10px;
      margin: 6px 0;
    }

    .modalItemBox {
      border-bottom: 1px solid #eee;
    }

    .default {
      display: inline-block;
    }

    .reset_radio_styles label {
      font-size: 12px;
      position: relative;
      top: -1px;
    }

    .errorTextBox {
      position: relative;

      .errorTxt {
        position: absolute;
        left: 0;
        bottom: -28px;
      }

      .errorPriceTxt {
        position: absolute;
        left: 178px;
        bottom: -28px;
      }
    }

    .errorStyles {
      position: absolute;
      left: 123px;
      bottom: -30px;
    }
  }
}
</style>